import { FeaturesI18N } from 'controls';

const bundle = new Map<string, string>([
  ['EMPTY', ''],
  ['NO', 'Нет'],
  ['YES', 'Да'],
  ['STRING', '{0}'],
  ['busy', 'Дождитесь окончания операции!'],
  ['dirty', 'Изменения не были сохранены. Всё равно продолжить?'],
  ['print.success', 'Документ отправлен на печать.'],
  ['print.failure', 'Ошибка печати!'],
  ['print.manual', 'Переверните листы в принтере для продолжения печати на оборотной стороне!'],
  ['JOBTOTAL', '{0} лет'],
  ['JOBBREAK', 'Заполните промежуток с {0} по {1}'],
  ['JOBNOW', 'настоящее время'],
  ['INVALID.DT', 'Дата и время указаны неверно!'],

  ['fail.http.connection', 'Отсутствует сетевое соединение с сервером.'],
  ['fail.http.400', 'Отправленные серверу данные имеют неверный формат.'],
  ['fail.http.401', 'Клиент не аутентифицирован на сервере.'],
  ['fail.http.404', 'Неверный адрес API.'],
  ['fail.http.500', 'Внутренняя ошибка сервера.'],
  ['fail.http.502', 'Сетевой шлюз или прокси сервер получил неверный ответ от восходящего сервера.'],
  ['fail.http.unknown', 'Неизвестная ошибка во время отправки данных на сервер.'],

  ['fail.auth.wrongMethod', 'Выбран неправильный тип аутентификации!'],

  [
    'fail.request.upload.invalid.format',
    'Не удалось загрузить данные из файла. Возможно, целостность файла была нарушена. Попробуйте повторить операцию выгрузки в файл.',
  ],
  ['fail.request.load', 'Не удалось загрузить заявление!'],
  ['fail.request.delete', 'Не удалось удалить заявление!'],
  ['fail.request.save', 'Не удалось сохранить заявление!'],
  ['fail.request.sync', 'Не удалось синхронизировать заявление!'],
  ['fail.request.sitefail', 'При заполнении заявления возникли ошибки. Исправьте их для дальнейшей работы.'],
  ['fail.request.sitesucc', 'Заявление сохранено.'],
  [
    'fail.keyboard.site',
    'Использование виртуальной клавиатуры доступно только с персональных компьютеров в браузерах Chrome, Firefox, Edge. Для заполнения анкеты на мобильном устройстве необходимо активировать русскую клавиатуру. Для этого воспользуйтесь инструкцией по эксплуатации используемого устройства.',
  ],
  ['fail.request.validate!', 'Обнаружены ошибки заполнения!'],
  ['fail.request.validate?', 'Обнаружены предупреждения по заполнению. Всё равно продолжить?'],
  ['fail.request.sendViaInternet', 'Не удалось отправить заявление!'],
  [
    'fail.request.sessionExpire',
    'Сессия работы с сайтом истекла! Введенные данные сохранены в заявление-черновик. Для продолжения работы с заявлением обновите страницу, найдите в списке нужное заявление и отредактируйте его.',
  ],

  ['fail.photo.upload', 'Ошибка при загрузке фотографии на сервер.'],
  ['fail.photo.upload.oversized', 'Загрузка изображений размером более 4МБ не допускается. Размер фото: {0}MB.'],
  ['fail.photo.upload.format', 'Ошибка загрузки фотографии. Недопустимый формат файла с фотографией.'],

  ['fail.feedback.send', 'При отправке отзыва возникла ошибка.'],
  ['fail.feedback.send.internal', 'Ошибка сервера при отправке отзыва.'],
  ['fail.feedback.send.captcha', 'Проверка длинности капчи не пройдена.'],

  ['menu.wizards', 'Создать'],
  ['menu.requests', 'Заявления'],
  ['menu.verify', 'Выдача'],
  ['menu.sync', 'Синхронизация'],
  ['menu.settings', 'Настройки'],
  ['menu.users', 'Пользователи'],
  ['menu.user', 'Пользователь'],
  ['menu.quit', 'Выход'],

  ['settings.date.submit', 'Изменить дату и время'],
  ['settings.date.error', 'Не удалось установить новое системное время'],
  ['settings.date.success', 'Установлено новое системное время'],

  [
    'integrity-title',
    'Целостность устройства нарушена. Функционал частично недоступен. После исправления проблемы, пожалуйста, перезагрузите устройство.',
  ],
  ['certificate-title', 'Сертификат шифрования просрочен или не удалось проверить цепочку сертификатов. Функционал частично недоступен.'],
  ['battery-title', 'Низкий уровень заряда'],
  [
    'battery-error',
    'Низкий уровень заряда. Устройство будет выключено через 60 секунд. Подключите устройство к источнику питания или сохраните последние изменения перед выключением.',
  ],
  ['battery-warning', 'Низкий уровень заряда. Подключите устройство к источнику питания.'],
  [
    'battery-camera-warning',
    'Низкий уровень заряда. Использование камеры невозможно. Подключите устройство к источнику питания для продолжения.',
  ],

  ['sync.dg3cert.begin', 'Начало срока действия сертификата шифрования отпечатков пальцев'],
  ['sync.dg3cert.end', 'Окончание срока действия сертификата шифрования отпечатков пальцев'],
  ['sync.dg3cert.info', 'Статус сертификата шифрования отпечатков пальцев'],
  ['sync.dg3cert.eBefore', 'Сертификат ещё не действует!'],
  ['sync.dg3cert.eAfter', 'Сертификат уже не действует!'],
  ['sync.dg3cert.wAfter', 'Сертификат скоро перестанет действовать!'],
  ['sync.dg3cert.ok', 'Сертификат действует.'],
  ['sync.dg3cert.unknown', 'Не удалось определить статус сертификата!'],
  ['sync.fingerprints.cert.command', 'Подготовка к выездному обслуживанию'],
  ['sync.command', 'Подготовка к длительному хранению'],
  ['sync.kladr.update.command', 'Обновить КЛАДР'],
  ['command.request.create.fromScratch', 'Ручной ввод заявления'],
  ['command.request.create.fromBarcode', 'Сканирование QR-кода'],
  ['command.request.sendViaInternet', 'Отправить'],
  ['command.request.modify', 'Редактировать'],
  ['command.request.verify', 'Верификация'],
  ['command.request.delete', 'Удалить'],
  ['command.request.restore', 'Восстановить'],
  ['command.request.qrdownload', 'Скачать QR-код'],
  ['command.request.ready', 'Готово'],
  ['command.request.export', 'Сохранить в файл'],
  ['command.request.import', 'Загрузить из файла'],
  ['command.request.queue', 'Записаться в очередь'],
  ['command.request.print.app', 'Печать'],
  ['command.request.printed.app', 'Раcпечатано'],
  ['command.request.print.cert', 'Печать справки'],
  ['command.request.print.flyleaf', 'Форзац'],
  ['command.request.print.card', 'Просмотр'],
  ['command.request.saveF', 'Черновик'],
  ['command.request.saveT', 'Сохранить'],
  ['command.request.abandon', 'Закрыть'],
  ['command.passphrase.reset', 'Сбросить пароль'],

  [
    'sync.status',
    'Найдено: {0}. Пропущено: {1}. Перенесено дублей заявлений: {2}. Перенесено новых заявлений: {3}. Стёрто: {4}. Номеров паспортов отправлено: {5}. Нoмеров паспортов найдено: {6}. Номеров паспортов не найдено: {7}. Номеров паспортов удалено: {8}',
  ],
  ['sync.addr.empty.warn', 'Не указан адрес сервера ПВДНП.'],
  ['sync.addr.get.error', 'Ошибка получения адреса сервера ПВДНП.'],
  ['sync.server.connection.error', 'Отсутствует соединение с сервером ПВДНП.'],
  ['sync.server.department.error', 'Неверный код подразделения.'],
  [
    'sync.fingerprints.certs.uploading.status',
    'Количество загруженных сообщений: {0}; с заменой сертификата: {1}; без замены сертификата: {2}',
  ],
  ['sync.fingerprints.certs.uploading.error', 'Ошибка загрузки сертификата шифрования отпечатков пальцев'],
  ['sync.fingerprints.no.certs', 'Отсутствуют сертификаты шифрования отпечатков пальцев для загрузки'],

  ['paginator.page.size', 'Размер страницы:'],
  ['paginator.page.curr1', 'Всего:'],
  ['paginator.page.curr2', 'Текущая страница:'],
  ['paginator.page.curr3', 'нет'],
  ['paginator.page.curr4', 'из'],
  ['paginator.page.next', 'Следующая страница'],
  ['paginator.page.prev', 'Предыдущая страница'],
  ['paginator.page.first', 'Первая страница'],
  ['paginator.page.last', 'Последняя страница'],

  ['button.cancel', 'Отмена'],
  ['button.close', 'Закрыть'],
  ['button.print', 'Печать'],
  ['button.clear', 'Очистить'],
  ['button.default', 'По умолчанию'],
  ['button.passport.verify', 'Считать'],
  ['button.passport.savePhoto', 'Сохранить фото'],
  ['button.passport.display', 'Показать'],
  ['button.passport.good', 'Паспорт верен'],
  ['button.passport.bad', 'Паспорт аннулирован'],
  ['button.passport.granted', 'Паспорт выдан'],

  ['dialog.title.applicant.nameChanges', 'Смена ФИО'],
  ['dialog.title.applicant.jobRecords', 'Место работы'],
  ['dialog.title.representative.nameChanges', 'Смена ФИО'],

  ['dialog.title.notification', 'Сообщение'],
  ['dialog.title.alert', 'Предупреждение'],
  ['dialog.title.confirmation', 'Подтверждение'],
  ['dialog.title.error', 'Ошибка'],
  ['dialog.button.cancel', 'Отмена'],
  ['dialog.button.close', 'Закрыть'],
  ['dialog.button.ok', 'ОК'],
  ['dialog.button.yes', 'Да'],
  ['dialog.button.no', 'Нет'],
  ['dialog.button.update', 'Обновить'],

  ['list.request.fail.find', 'Не удалось загрузить список заявлений!'],
  ['list.request.fail.uid', 'Не удалось сгенерировать UID заявления!'],

  ['wizard.button.back', 'Назад'],
  ['wizard.button.forward', 'Далее'],
  ['wizard.button.cancel', 'Выход'],
  ['wizard.button.finish', 'Готово'],

  ['wizard.button.photo.up', 'Вверх'],
  ['wizard.button.photo.down', 'Вниз'],
  ['wizard.button.photo.shoot', 'Съёмка'],

  ['cabin.server.lost', 'Ошибка сервера!'],
  ['cabin.device.lost', 'Ошибка ФК!'],
  ['cabin.device.busy', 'ФК занята!'],

  ['ENUM.FingerprintsRequired.0', 'Не требуются'],
  ['ENUM.FingerprintsRequired.1', 'Требуются'],

  ['ENUM.ForeignPassportType.1', 'Заграничный'],
  ['ENUM.ForeignPassportType.2', 'Дипломатический'],
  ['ENUM.ForeignPassportType.3', 'Служебный'],

  ['ENUM.Gender.0', 'МУЖСКОЙ'],
  ['ENUM.Gender.1', 'ЖЕНСКИЙ'],

  ['ENUM.AgeGroup.0', 'Совершеннолетний'],
  ['ENUM.AgeGroup.1', 'Несовершеннолетний от 14 до 18'],
  ['ENUM.AgeGroup.2', 'Несовершеннолетний до 14'],

  ['ENUM.RequestGoal.0', 'Временные выезды за границу'],
  ['ENUM.RequestGoal.1', 'Проживание за границей'],

  ['ENUM.RequestCause.0', 'Первичное'],
  ['ENUM.RequestCause.1', 'Взамен использованного'],
  ['ENUM.RequestCause.2', 'Взамен испорченного'],
  ['ENUM.RequestCause.3', 'Взамен утраченного'],
  ['ENUM.RequestCause.4', 'Второй паспорт на срок действия первого'],
  ['ENUM.RequestCause.5', 'В дополнение к имеющемуся'],

  ['ENUM.RequestCauseV2.0', 'Первичное'],
  ['ENUM.RequestCauseV2.3', 'Взамен утраченного'],
  ['ENUM.RequestCauseV2.6', 'Взамен использованного/испорченного'],
  ['ENUM.RequestCauseV2.7', 'Взамен действующего'],
  ['ENUM.RequestCauseV2.8', 'В дополнение к действующему'],

  ['ENUM.RestrictionV2.0', 'Нет'],
  ['ENUM.RestrictionV2.1', 'Да'],

  ['ENUM.RepresentativeProofDocumentTypeV2.1', 'Свидетельство о рождении несовершеннолетнего'],
  ['ENUM.RepresentativeProofDocumentTypeV2.6', 'Документ, подтверждающий полномочия опекуна/попечителя'],

  ['ENUM.TempAddressTypeV2.0', 'Места пребывания'],
  ['ENUM.TempAddressTypeV2.1', 'Фактического проживания'],

  ['ENUM.IndependentChildDocumentTypeV2.7', 'Решение суда Российской Федерации'],
  ['ENUM.IndependentChildDocumentTypeV2.8', 'Свидетельство о браке российского образца'],
  ['ENUM.IndependentChildDocumentTypeV2.9', 'Решение органов опеки Российской Федерации'],

  ['ENUM.ApplicantIdentityDocumentType.1', 'Свидетельство о рождении'],
  ['ENUM.ApplicantIdentityDocumentType.3', 'Паспорт гражданина РФ'],
  ['ENUM.ApplicantIdentityDocumentType.5', 'Документ отсутствует'],

  ['ENUM.RepresentativeIdentityDocumentType.0', 'Произвольный документ'],
  ['ENUM.RepresentativeIdentityDocumentType.3', 'Паспорт гражданина РФ'],
  ['ENUM.RepresentativeIdentityDocumentType.4', 'Заграничный паспорт гражданина РФ'],

  ['ENUM.AdultSpecialConditions.0', 'Нет'],
  ['ENUM.AdultSpecialConditions.1', 'Решение о вступлении в гражданство'],
  ['ENUM.AdultSpecialConditions.2', 'Указ президента о вступлении в гражданство'],
  ['ENUM.AdultSpecialConditions.3', 'Разрешение командования'],

  ['ENUM.TeenagerSpecialConditions.0', 'Нет'],
  ['ENUM.TeenagerSpecialConditions.1', 'Решение о вступлении в гражданство'],
  ['ENUM.TeenagerSpecialConditions.2', 'Указ президента о вступлении в гражданство'],

  ['ARRAY.NameChange.lastName', 'Фамилия'],
  ['ARRAY.NameChange.firstName', 'Имя'],
  ['ARRAY.NameChange.middleName', 'Отчество'],
  ['MISS.ARRAY.NameChange.middleName', 'Нет'],
  ['ARRAY.NameChange.year', 'Дата смены ФИО'],
  ['ARRAY.NameChange.location', 'Место'],

  ['ARRAY.NameChangeForRep.lastName', 'Фамилия'],
  ['ARRAY.NameChangeForRep.firstName', 'Имя'],
  ['ARRAY.NameChangeForRep.middleName', 'Отчество'],
  ['MISS.ARRAY.NameChangeForRep.middleName', 'Нет'],
  ['ARRAY.NameChangeForRep.year', 'Год'],
  ['ARRAY.NameChangeForRep.location', 'Место'],

  ['ARRAY.JobRecord.position', 'Должность, организация'],
  ['ARRAY.JobRecord.address', 'Адрес организации'],
  ['ARRAY.JobRecord.from', 'Начало (ММ ГГГГ)'],
  ['ARRAY.JobRecord.to', 'Окончание (ММ ГГГГ)'],
  ['MISS.ARRAY.JobRecord.to', 'Н.ВР.'],

  ['CORTEGE.RequestFeatures.Default', 'По умолчанию'],
  ['CORTEGE.RequestFeatures.Control', 'Контроль'],
  ['CORTEGE.RequestFeaturesV2.Default', 'По умолчанию'],
  ['CORTEGE.RequestFeaturesV2.Control', 'Контроль'],
  ['COLUMN.UID', '№'],
  ['COLUMN.STATUS', 'Статус'],

  ['COLUMN.RequestFeatures.applicant.gender', 'Пол'],
  ['COLUMN.RequestFeatures.applicant.personIdentity.fullName.lastName', 'Фамилия'],
  ['COLUMN.RequestFeatures.applicant.personIdentity.fullName.firstName', 'Имя'],
  ['COLUMN.RequestFeatures.applicant.personIdentity.fullName.middleName', 'Отчество'],
  ['COLUMN.RequestFeatures.applicant.personIdentity.birthDate', 'Д.Р.'],
  ['COLUMN.RequestFeatures.mailing.active', 'Отправка почтой'],
  ['COLUMN.RequestFeatures._dept', 'Учреждение'],
  ['COLUMN.RequestFeatures._printed', 'Распечатано'],

  ['COLUMN.RequestFeaturesV2.applicant.gender', 'Пол'],
  ['COLUMN.RequestFeaturesV2.applicant.personIdentity.fullName.lastName', 'Фамилия'],
  ['COLUMN.RequestFeaturesV2.applicant.personIdentity.fullName.firstName', 'Имя'],
  ['COLUMN.RequestFeaturesV2.applicant.personIdentity.fullName.middleName', 'Отчество'],
  ['COLUMN.RequestFeaturesV2.applicant.personIdentity.birthDate', 'Д.Р.'],
  ['COLUMN.RequestFeaturesV2.mailing.active', 'Отправка почтой'],
  ['COLUMN.RequestFeaturesV2._dept', 'Учреждение'],
  ['COLUMN.RequestFeaturesV2._printed', 'Распечатано'],
  ['COLUMN.RequestFeaturesV2.applicant.personIdentity.birthDate', 'ДР'],
  ['COLUMN.RequestFeaturesV2.asString_', 'ФИО'],

  ['STATUS.RequestFeatures.DATA_ENTERED', 'Данные введены'],
  ['STATUS.RequestFeatures.READY', 'Готово'],
  ['STATUS.RequestFeatures.SENT', 'Отправлено'],
  ['STATUS.RequestFeatures.DELETED', 'Удалено'],

  ['STATUS.RequestFeaturesV2.DATA_ENTERED', 'Данные введены'],
  ['STATUS.RequestFeaturesV2.READY', 'Готово'],
  ['STATUS.RequestFeaturesV2.SENT', 'Отправлено'],
  ['STATUS.RequestFeaturesV2.DELETED', 'Удалено'],

  ['STATUS.BIOPASSPORT.DATA_ENTERED', 'Черновик'],
  ['STATUS.BIOPASSPORT.READY', 'Заявление готово для подачи'],
  ['STATUS.BIOPASSPORT.SENT', 'Отправлено'],
  ['STATUS.BIOPASSPORT.DELETED', 'Удалено'],
  ['STATUS.BIOPASSPORT.INFO_IN_PROGRESS', 'Документы приняты'],
  ['STATUS.BIOPASSPORT.INFO_PROBLEM', 'Заявление отклонено'],
  ['STATUS.BIOPASSPORT.INFO_READY', 'Паспорт готов к выдаче'],
  ['STATUS.BIOPASSPORT.INFO_SUCCESS', 'Работа с заявлением завершена'],
  ['STATUS.BIOPASSPORT.INFO_MAIL', 'Паспорт направлен почтой'],
  ['STATUS.BIOPASSPORT.INFO_PENDING_DATA_PROCESSING', 'Данные в обработке'],
  ['STATUS.BIOPASSPORT.INFO_DOCUMENTS_IN_PROCESSING', 'Документы в обработке'],

  ['ENUM.EnStatus.0', 'Заявление создано'],
  ['ENUM.EnStatus.1', 'Готово'],
  ['ENUM.EnStatus.3', 'Удалено'],
  ['ENUM.EnStatus.4', 'Отказ в согласовании'],
  ['ENUM.EnStatus.6', 'Ожидает обработки'],
  ['ENUM.EnStatus.7', 'Паспорт поступил'],
  ['ENUM.EnStatus.9', 'Паспорт верен'],
  ['ENUM.EnStatus.10', 'Паспорт выдан'],
  ['ENUM.EnStatus.11', 'Паспорт аннулирован'],
  ['ENUM.EnStatus.14', 'На персонализации'],
  ['ENUM.EnStatus.15', 'Паспорт напечатан'],
  ['ENUM.EnStatus.16', 'Паспорт отправлен в РКЗУ'],
  ['ENUM.EnStatus.17', 'Паспорт утилизирован'],
  ['ENUM.EnStatus.19', 'Согласовано письмом'],
  ['ENUM.EnStatus.20', 'Принято в обработку'],
  ['ENUM.EnStatus.21', 'На согласовании'],
  ['ENUM.EnStatus.23', 'Согласовано'],
  ['ENUM.EnStatus.25', 'Ошибка при персонализации'],
  ['ENUM.EnStatus.27', 'Работа завершена'],
  ['ENUM.EnStatus.28', 'Возврат без исполнения'],
  ['ENUM.EnStatus.29', 'Паспорт поступил в РКЗУ'],
  ['ENUM.EnStatus.30', 'Отклонено'],
  ['ENUM.EnStatus.31', 'Дополнительная проверка'],
  ['ENUM.EnStatus.32', 'На согласовании (заявление)'],
  ['ENUM.EnStatus.33', 'Отправлен запрос'],
  ['ENUM.EnStatus.34', 'Паспорт передан на выдачу'],
  ['ENUM.EnStatus.35', 'Приостановлено'],
  ['ENUM.EnStatus.36', 'Требует срочного согласования'],
  ['ENUM.EnStatus.37', 'Отправлено на согласование'],
  ['ENUM.EnStatus.38', 'Отправлено'],
  ['ENUM.EnStatus.39', 'Отправлено в МРЦОД'],
  ['ENUM.EnStatus.40', 'Отмена изготовления паспорта'],
  ['ENUM.EnStatus.41', 'Почтовое отправление'],
  ['ENUM.EnStatus.42', 'Паспорт подлежит утилизации'],
  ['ENUM.EnStatus.44', 'Паспорт активирован'],
  ['ENUM.EnStatus.45', 'Уведомление об отказе в оформлении'],
  ['ENUM.EnStatus.242', 'Отправлены паспортные данные'],
  ['ENUM.EnStatus.243', 'Разрешение клонирования'],
  ['ENUM.EnStatus.245', 'Изменение приоритета заявления'],
  ['ENUM.EnStatus.246', 'Ожидает отметку о согласовании'],
  ['ENUM.EnStatus.247', 'Изменение паспортных данных'],
  ['ENUM.EnStatus.249', 'Восстановлено'],
  ['ENUM.EnStatus.251', 'Изменение способа согласования'],
  ['ENUM.EnStatus.252', 'Проверка по МИД: начало'],
  ['ENUM.EnStatus.253', 'Проверка по МИД: положительный результат'],
  ['ENUM.EnStatus.254', 'Проверка по МИД: негативный результат'],
  ['ENUM.EnStatus.255', 'Возобновлено'],
  ['ENUM.EnStatus.261', 'Отмена события'],
  ['ENUM.EnStatus.263', 'Комментарий'],
  ['ENUM.EnStatus.264', 'На персонализации'],
  ['ENUM.EnStatus.268', 'Паспорт напечатан'],
  ['ENUM.EnStatus.270', 'МРЦОД: окончание бизнес-процесса'],
  ['ENUM.EnStatus.271', 'АИС: начата проверка гражданства'],
  ['ENUM.EnStatus.272', 'АИС: результат проверки гражданства'],
  ['ENUM.EnStatus.273', 'АИС: истекло время проверки гражданства'],
  ['ENUM.EnStatus.274', 'АИС: начата проверка паспортов'],
  ['ENUM.EnStatus.275', 'АИС: результат проверки паспортов'],
  ['ENUM.EnStatus.276', 'АИС: истекло время проверки паспортов'],
  ['ENUM.EnStatus.281', 'Загружены отпечатки пальцев'],
  ['ENUM.EnStatus.282', 'Удалены отпечатки пальцев'],
  ['ENUM.EnStatus.283', 'Смена типа получения'],
  ['ENUM.EnStatus.284', 'Отправленное в МРЦОД подписано'],
  ['ENUM.EnStatus.285', 'Персонализация разрешена'],
  ['ENUM.EnStatus.310', 'Паспорт передан на хранение'],
  ['ENUM.EnStatus.320', 'Паспорт выдан с хранения'],
  ['ENUM.EnStatus.500', 'Данные введены'],
  ['ENUM.EnStatus.502', 'Клонирование'],
  ['ENUM.EnStatus.503', 'Персональные данные удалены'],
  ['ENUM.EnStatus.505', 'Изменение флага о прочтении комментария'],
  ['ENUM.EnStatus.600', 'Ошибка'],
  ['ENUM.EnStatus.603', 'Отклонено на ЛЦОД'],
  ['ENUM.EnStatus.1000', 'Тестовое событие'],
  // Устаревшие, но необходимо отображать в истории с префиксом "_"
  ['ENUM.EnStatus.2', '_Заявление на согласовании'],
  ['ENUM.EnStatus.8', '_Паспорт отклонен'],
  ['ENUM.EnStatus.12', '_Паспорт утрачен'],
  ['ENUM.EnStatus.13', '_Заявление доставлено'],
  ['ENUM.EnStatus.18', '_Пакет удален из базы'],
  ['ENUM.EnStatus.22', '_Принято решение об изготовлении паспорта'],
  ['ENUM.EnStatus.24', '_Заявление на персонализации'],
  ['ENUM.EnStatus.244', '_Заявление клонировано'],
  ['ENUM.EnStatus.248', '_Редактирование'],
  ['ENUM.EnStatus.256', '_Ошибка согласования'],
  ['ENUM.EnStatus.259', '_Прототип заявления'],
  ['ENUM.EnStatus.501', '_Изменение хэша ФИО'],

  ['ENUM.EnColumn.0', 'Номер заявления'],
  ['ENUM.EnColumn.1', 'Дата приема'],
  ['ENUM.EnColumn.2', 'Дата смены статуса'],
  ['ENUM.EnColumn.3', 'Фамилия'],
  ['ENUM.EnColumn.4', 'Имя'],
  ['ENUM.EnColumn.5', 'Отчество'],
  ['ENUM.EnColumn.6', 'Дата рождения'],
  ['ENUM.EnColumn.7', 'Состояние'],
  ['ENUM.EnColumn.8', 'Номер паспорта'],
  ['ENUM.EnColumn.9', 'Оператор'],
  ['ENUM.EnColumn.10', 'Тип паспорта'],
  ['ENUM.EnColumn.11', 'Приоритет'],
  ['ENUM.EnColumn.12', 'Дата выдачи'],
  ['ENUM.EnColumn.13', 'Годен до'],
  ['ENUM.EnColumn.14', 'Код организации'],
  ['ENUM.EnColumn.15', 'Название организации'],
  ['ENUM.EnColumn.16', 'Наличие отпечатков'],
  ['ENUM.EnColumn.17', 'Статус разрешения клонирования'],
  ['ENUM.EnColumn.18', 'Доставка паспорта почтой'],
  ['ENUM.EnColumn.19', 'Гражданство, полученное в течение последних 3-х мес.'],
  ['ENUM.EnColumn.20', 'Военнослужащий по решению командования'],
  ['ENUM.EnColumn.21', 'Возраст'],
  ['ENUM.EnColumn.22', 'Телефон'],
  ['ENUM.EnColumn.24', 'Дата планирования следующего действия'],
  ['ENUM.EnColumn.25', 'Дата создания заявления'],
  ['ENUM.EnColumn.26', 'Дата справки о гражданстве'],
  ['ENUM.EnColumn.27', 'Режим получения'],
  ['ENUM.EnColumn.28', 'Выездное обслуживание'],
  ['ENUM.EnColumn.29', 'Название подразделения'],
  ['ENUM.EnColumn.30', 'Количество ошибок в заявлении'],
  ['ENUM.EnColumn.31', 'Дата приостановки'],

  ['ENUM.InputMedia.0', 'Ручной ввод'],
  ['ENUM.InputMedia.1', 'Сканирование'],
  ['ENUM.InputMedia.2', 'Сообщение BA'],
  ['ENUM.InputMedia.3', 'Двумерный штрихкод'],
  ['ENUM.InputMedia.4', 'Загрузка из файла'],
  ['ENUM.InputMedia.5', 'Копирование'],

  ['ENUM.RequestPriority.', ' '],
  ['ENUM.RequestPriority.0', 'В обычном порядке'],
  ['ENUM.RequestPriority.1', 'Ускоренно'],
  ['ENUM.RequestPriority.2', 'Срочно'],

  ['search.bar.find', 'Поиск'],
  ['search.bar.clear', 'Очистить'],
  ['search.bar.by.first.letters', 'по первым буквам'],
  ['search.field.from', 'с:'],
  ['search.field.to', 'по:'],
  ['field.from_and_to', 'Выбрать диапазон'],
  ['field.app_from_and_to', 'Выбрать диапазон'],
  ['field.rep_from_and_to', 'Выбрать диапазон'],
  ['search.field.boolean.unknown', '-'],
  ['search.field.boolean.false', 'нет'],
  ['search.field.boolean.true', 'да'],

  ['request.root.search.fields.tab.name', 'Поиск по персональным данным'],
  ['request.features.search.fields.tab.name', 'Поиск по заявлениям'],
  ['request.history.search.fields.tab.name', 'Поиск по истории'],
  ['search.bar.field.status', 'Статус'],
  ['search.bar.modified.date', 'Дата последней модификации событий'],
  ['search.bar.status.change.date', 'Дата первоначального возникновения статуса'],
  ['search.bar.fields.event.type', 'Тип события в истории'],
  ['search.bar.fields.event.created', 'Дата события'],

  ['SEARCH.OPTION.EXACT', 'точное совпадение'],
  ['SEARCH.OPTION.INTERVAL', 'интервал'],

  ['field.fingerprintsRequired', 'Отпечатки пальцев'],
  ['field.incapable', 'Недееспособен / ограниченно дееспособен'],
  ['field.independentChild', 'Объявлен полностью дееспособным'],
  ['field.any.miss', 'Нет'],
  ['field.permAddress', 'Адрес места жительства'],
  ['field.tempAddress', 'Временная регистрация'],
  ['field.address.copyPerm', 'Подставить место жительства'],
  ['field.permAddress2', 'Адрес места жительства'],
  ['field.tempAddress2', 'Адрес'],
  ['field.address2.copyAppPermAddressToTempAddress', 'Подставить место жительства'],
  ['field.address2.copyRepPermAddressToTempAddress', 'Подставить место жительства'],
  ['field.address2.copyAppPermAddressToRepPermAddress', 'Подставить место жительства заявителя'],
  ['field.address2.copyAppTempAddressToRepTempAddress', 'Подставить адрес пребывания заявителя'],
  ['field.gender', 'Пол'],
  ['field.lastName', 'Фамилия'],
  ['field.lastNameLat', 'Фамилия (лат.)'],
  ['field.firstName', 'Имя'],
  ['field.firstNameLat', 'Имя (лат.)'],
  ['field.middleName', 'Отчество'],
  ['field.birthDate', 'Дата рождения'],
  ['field.nameChanges', 'Изменения ФИО'],
  ['field.nameChanges.same', 'Не менял(а)'],
  ['field.jobRecords', 'Трудовая деятельность'],
  ['field.jobRecords.unemployed', 'Не работал(а)'],
  ['field.jobRecords.unemployed-male', 'НЕ РАБОТАЛ И НЕ УЧИЛСЯ'],
  ['field.jobRecords.unemployed-female', 'НЕ РАБОТАЛА И НЕ УЧИЛАСЬ'],
  ['field.jobRecords.copyPermAddress', 'Место жительства'],
  ['field.jobRecords.copyTempAddress', 'Адрес места пребывания'],
  ['field.jobManDate', 'Дата заверения'],
  ['field.jobManName', 'Заверившее лицо'],
  ['field.birthPlaceFull', 'Полное место рождения'],
  ['field.birthPlaceRus', 'Место рождения'],
  ['field.birthPlaceLat', 'Место рождения (лат.)'],
  ['field.birthPlace', 'Место рождения'],
  ['field.address', 'Адрес'],
  ['field.index', 'Индекс'],
  ['field.country', 'Страна'],
  ['field.admDivision', 'Субъект федерации'],
  ['field.region', 'Район'],
  ['field.settlement', 'Населённый пункт'],
  ['field.street', 'Улица'],
  ['field.building', 'Дом'],
  ['field.housing', 'Корпус'],
  ['field.structure', 'Строение'],
  ['field.flat', 'Квартира'],
  ['field.email', 'E-mail'],
  ['field.phone', 'Телефон'],
  ['field.registered', 'Дата регистрации'],
  ['field.from', 'Начало срока регистрации'],
  ['field.to', 'Окончание срока регистрации'],
  ['field.secondNationality', 'Второе гражданство'],
  ['field.docType', 'Тип документа'],
  ['field.independentChildDocType', 'Документ, подтверждающий дееспособность заявителя'],
  ['field.representativeProofDocType', 'Документ, подтверждающий права законного представителя'],
  ['field.docSeries', 'Серия'],
  ['field.docNumber', 'Номер'],
  ['field.docIssuer', 'Выдан'],
  ['field.docIssueDate', 'Дата выдачи'],
  ['field.docExpireDate', 'Годен до'],
  ['field.docMustBeCanceled', 'Будет представлен для аннулирования'],
  ['field.docLost', 'Утрачен'],
  ['field.activeFPassport', 'Имеется действующий заграничный паспорт'],
  ['field.nextActiveFPassport', 'Имеется второй заграничный паспорт'],
  ['field.goal', 'Цель получения паспорта'],
  ['field.cause', 'Получение паспорта'],
  ['field.residenceCountry', 'Страна проживания'],
  ['field.secretAccess', 'Был/имеется допуск к сведениям особой важности или совершенно секретным сведениям'],
  ['field.secretAccess.miss', 'Нет'],
  ['field.departureRestrictions', 'Договорные или контрактные обязательства, препятствующие выезду за границу'],
  ['field.departureRestrictions.miss', 'Нет'],
  ['field.militaryService', 'Призван(а) на военную или направлен(а) на альтернативную службу'],
  ['field.militaryService.miss', 'Нет'],
  ['field.conviction', 'Осужден(а) за совершение преступления либо привлечен(а) в качестве обвиняемого'],
  ['field.conviction.miss', 'Нет'],
  ['field.legalObligations', 'Уклонение от обязательств, наложенных судом'],
  ['field.legalObligations.miss', 'Нет'],
  ['field.contractObligations', 'Договорные или контрактные обязательства, препятствующие выезду за границу'],
  ['field.convicted', 'Осужден(а) за совершение преступления'],
  ['field.accused', 'Являетесь подозреваемым или обвиняемым'],
  ['field.bankrupt', 'Признан(а) несостоятельным/банкротом'],
  ['field.restrictionOrganization', 'Организация'],
  ['field.restrictionYear', 'Год'],
  ['field.dipServiceControlData.dutyOrganization', 'Направляющая организация'],
  ['field.dipServiceControlData.dutyPosition', 'Должность, место работы'],
  ['field.dipServiceControlData.dutyDuration', 'Срок'],
  ['field.dipServiceControlData.dutyCountry', 'Страна'],
  ['field.dipServiceControlData.secretAdmitted', 'Допуск по форме №1 и №2 к сведениям, составляющим гос. тайну'],
  ['field.dipServiceControlData.secretAware', 'Осведомлен(а) в сов. секретных или особой важности сведениях, составляющих гос. тайну'],
  ['field.dipServiceControlData.contracts', 'Договорные или контрактные обязательства, препятствующие выезду за границу'],
  ['field.dipServiceControlData.trips', 'Был(а) ли ранее за границей'],
  ['field.trustRecipient', 'Получение паспорта другим законным представителем'],
  ['field.trustRecipient.active', 'Законный представитель не возражает против получения паспорта другим законным представителем'],
  ['field.mailing.active', 'Отправка почтой'],
  ['field.mailing.addressRus', 'Адрес доставки'],
  ['field.mailing.addressLat', 'Адрес доставки (лат.)'],
  ['field.citizenshipCertificate.active', 'Заключение о наличии гражданства'],
  ['field.citizenshipCertificate.number', 'Номер заключения'],
  ['field.citizenshipCertificate.date', 'Дата заключения'],
  ['field.citizenshipCertificate.officerPost', 'Должность заверителя'],
  ['field.citizenshipCertificate.officerName', 'Ф.И.О. заверителя'],
  ['field.citizenshipCertificate.testimony', 'Текст заключения'],
  ['field.adultSpecialConditions', 'Особые условия'],
  ['field.teenagerSpecialConditions', 'Особые условия'],
  ['field.citizenshipDecision.number', 'Номер заявления'],
  ['field.citizenshipDecision.date', 'Дата решения'],
  ['field.citizenshipDecision.officerPost', 'Должность руководителя'],
  ['field.citizenshipDecision.officerName', 'Ф.И.О. руководителя'],
  ['field.citizenshipDecision.article', 'Статья'],
  ['field.presidentEdict.number', 'Номер указа'],
  ['field.presidentEdict.date', 'Дата указа'],
  ['field.soldierPermission.number', 'Номер справки'],
  ['field.soldierPermission.date', 'Дата справки'],
  ['field.soldierPermission.signerPost', 'Должность подписавшего справку'],
  ['field.soldierPermission.signerName', 'Ф.И.О. подписавшего справку'],
  ['field.soldierPermission.agreementNumber', 'Номер согласования ФСБ'],
  ['field.soldierPermission.agreementDate', 'Дата согласования ФСБ'],
  ['field.soldierPermission.deciderName', 'Ф.И.О. принявшего решение о выдаче паспорта'],
  ['field.soldierPermission.militaryUnit', 'Номер военной части'],
  ['field.receptionUser', 'Ф.И.О. принявшего заявление'],
  ['field.sendAppViaInternet', 'Отправить заявление через Интернет'],
  ['field.sendAppViaInternetWithFIO', 'Отправить заявление с указанием ФИО и даты рождения'],
  ['field.justification.presidentEdict', 'Указ №{0} от {1}'],
  [
    'field.justification.soldierPermission',
    'Справка №{0} от {1}, подписал {2} {3}, согласование №{4} от {5}, принял решение {6}, в/ч №{7}',
  ],
  ['field.justification.citizenshipDecision', 'Заявление №{0}, решение от {1} {2} {3} на основании {4}'],

  [
    'info.latName',
    'Латинская транслитерация фамилия и имени в заявлении производится автоматически. Если вас не устраивает предложенное написание, то при подаче документов в консульское учреждение вам будет предложено написать заявление о смене транслитерации, указав в нем причину изменения и предоставить документ, подтверждающий это.',
  ],
  ['info.dateFormat', 'Дата в формате ДД.ММ.ГГГГ или ДД.МММ.ГГГГ. Например: «28.07.2001», «28.ИЮЛ.2001».'],
  [
    'info.incapable',
    'Если вы подаете заявление за совершеннолетнего гражданина, признанного недееспособным, отметьте данный чек-бокс и укажите сведения о законном представителе гражданина в соответствующем разделе ниже.',
  ],
  [
    'info.independentChild',
    'Отметьте данный чек-бокс, если заявление подается от имени гражданина, приобретшего полную дееспособность в результате заключения брака до достижения 18 лет, или если он работает по трудовому договору или с согласия родителей/усыновителей/попечителя занимается предпринимательской деятельностью. Требуется подтвердить полную дееспособность гражданина, указав необходимые документы в соответствующем разделе ниже.',
  ],
  [
    'info.birthPlaceFull',
    'Наименование Вашего места рождения, как указано во внутреннем паспорте или свидетельстве о рождении. Например: «РОССИЯ, ТУЛЬСКАЯ ОБЛАСТЬ, БЕЛЕВСКИЙ РАЙОН, ЗАЙЦЕВО», «БЕЛАРУСЬ, МОГИЛЁВСКАЯ ОБЛАСТЬ, МОГИЛЁВ»',
  ],
  [
    'info.birthPlaceRus',
    `
    Если Вы родились на территории РФ – наименование субъекта РФ (республики, края, области) или его центра. Например: «КРАСНОДАРСКИЙ КРАЙ», «МОСКВА», «ТУЛА».
    Если Вы родились на территории бывшего СССР (до 6 февраля 1992 г.) - наименование бывшей союзной республики, автономной республики, края, области или наименование республиканского, краевого или областного центра, если Вы родились в данном центре. Например: «БЕЛАРУСЬ».
    Если Вы родились за пределами РФ или бывшего СССР – наименование государства на русском языке. Например: «ФРАНЦИЯ», «США».`,
  ],
  [
    'info.birthPlaceLat',
    'Если Вы родились на территории РФ после распада СССР – «RUSSIA». На территории бывшего СССР – «USSR». За пределами РФ или бывшего СССР – наименование государства на английском языке. Например: «FRANCE», «USA».',
  ],
  [
    'info.applicantDocType',
    'Для граждан, достигших 14-летнего возраста – паспорт гражданина РФ (внутренний). Для граждан младше 14 лет – свидетельство о рождении, подтверждающее гражданство РФ. При отсутствии нужного документа - значение «Документ отсутствует».',
  ],
  [
    'info.representativeDocType',
    'Документ, удостоверяющий личность законного представителя и признаваемый Российской Федерацией в этом качестве.',
  ],
  [
    'info.independentChildDocType',
    'Внесите данные одного из документов, подтверждающих полную дееспособность несовершеннолетнего гражданина: свидетельство о заключении брака несовершеннолетнего, решение органа опеки и попечительства, или сведения о решении суда об объявлении несовершеннолетнего полностью дееспособным. Все документы должны быть выданы на территории РФ.',
  ],
  ['info.cause', 'При оформлении паспорта по причине смены ФИО нужно выбирать значение «Взамен действующего».'],
  ['info.phone', 'Телефон по месту регистрации, включая код страны и города. Например, «+1-987-123-45-67».'],
  [
    'info.secretAccessOrganization',
    `Укажите через запятую полное наименование организации, в котором был оформлен допуск, и форму допуска. Например, "ООО ОРГАНИЗАЦИЯ, 2-я форма допуска".`,
  ],
  [
    'info.contractObligationsOrganization',
    'Укажите полное наименование организации, с которой были заключены договорные или контрактные обязательства.',
  ],
  ['info.contractObligationsYear', 'Укажите год, когда были заключены договорные или контрактные обязательства.'],
  ['info.restrictionYear', 'Укажите год, когда был оформлен допуск.'],
  [
    'info.mailingActive',
    'Административными регламентами МИД России, регулирующими порядок оформления и выдачи загранпаспортов, предусмотрена возможность направления оформленных паспортов заявителям по почте. Для того, чтобы воспользоваться этой услугой, при подаче документов в консульское учреждение вам необходимо приложить заявление с просьбой направить паспорт почтовой связью, а также документ, подтверждающий оплату почтового отправления заявителем или его законным представителем.',
  ],
  [
    'info.representativeAddress',
    'Если у Вас есть постоянная регистрация на территории РФ – адрес регистрации. В ином случае – адрес проживания за рубежом. Адрес указывается по-русски в следующем формате: индекс, страна/республика, край, область, населенный пункт, улица, дом и квартира.',
  ],

  ['VALIDATION.RequestFeatures.REQUIRED.applicant.gender.value', 'Укажите пол заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.personIdentity.fullName.lastName', 'Укажите фамилию заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.personIdentity.fullName.lastName', 'Длина фамилии заявителя превышает 34 символа'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.personIdentity.fullName.lastName', 'Фамилия заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.WARN_FORMAT.applicant.personIdentity.fullName.lastName', 'Фамилия заявителя содержит римские цифры'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.personIdentity.fullName.firstName', 'Укажите имя заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.personIdentity.fullName.firstName', 'Длина имени заявителя превышает 40 символов'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG_SUM.applicant.personIdentity.fullName.firstName',
    'Суммарная длина имени и отчества заявителя превышает 39 символов',
  ],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.personIdentity.fullName.firstName', 'Имя заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.WARN_FORMAT.applicant.personIdentity.fullName.firstName', 'Имя заявителя содержит римские цифры'],
  [
    'VALIDATION.RequestFeatures.GENDER_MISMATCH.applicant.personIdentity.fullName.firstName',
    'Имя заявителя не соответствует полу заявителя',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.personIdentity.fullName.middleName.value', 'Укажите отчество заявителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.personIdentity.fullName.middleName.value',
    'Длина отчества заявителя превышает 38 символов',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG_SUM.applicant.personIdentity.fullName.middleName.value',
    'Суммарная длина имени и отчества заявителя превышает 39 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.personIdentity.fullName.middleName.value',
    'Отчество заявителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.WARN_FORMAT.applicant.personIdentity.fullName.middleName.value',
    'Отчество заявителя содержит римские цифры',
  ],
  [
    'VALIDATION.RequestFeatures.GENDER_MISMATCH.applicant.personIdentity.fullName.middleName.value',
    'Отчество заявителя не соответствует полу заявителя',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.personIdentity.birthDate.value', 'Укажите дату рождения заявителя'],
  ['VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.personIdentity.birthDate.value', 'Недопустимая дата рождения заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.nameChanges.lastName', 'Укажите предыдущую фамилию заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.nameChanges.lastName', 'Длина предыдущей фамилии заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.nameChanges.lastName', 'Предыдущая фамилия заявителя содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeatures.WARN_FORMAT.applicant.nameChanges.lastName',
    'Предыдущая фамилия заявителя содержит римские цифры или цифры',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.nameChanges.firstName', 'Укажите предыдущее имя заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.nameChanges.firstName', 'Длина предыдущего имени заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.nameChanges.firstName', 'Предыдущее имя заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.WARN_FORMAT.applicant.nameChanges.firstName', 'Предыдущее имя заявителя содержит римские цифры или цифры'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.nameChanges.middleName.value', 'Укажите предыдущее отчество заявителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.nameChanges.middleName.value',
    'Длина предыдущего отчества заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.nameChanges.middleName.value',
    'Предыдущее отчество заявителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.WARN_FORMAT.applicant.nameChanges.middleName.value',
    'Предыдущее отчество заявителя содержит римские цифры или цифры',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.nameChanges.year.value', 'Укажите год смены ФИО заявителя'],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.applicant.nameChanges.year.value',
    'Год смены ФИО заявителя меньше даты рождения заявителя',
  ],
  ['VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.nameChanges.year.value', 'Недопустимый год смены ФИО заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.nameChanges.location', 'Укажите место смены ФИО заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.nameChanges.location', 'Длина места смены ФИО заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.nameChanges.location', 'Место смены ФИО заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.MATCH.applicant.nameChanges', 'Последняя запись о смене ФИО заявителя совпадает с ФИО заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.lastNameLat', 'Укажите фамилию заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.lastNameLat', 'Длина фамилии заявителя превышает 36 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.lastNameLat', 'Фамилия заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.firstNameLat', 'Укажите имя заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.firstNameLat', 'Длина имени заявителя превышает 42 символа'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.firstNameLat', 'Имя заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.birthPlaceFull', 'Укажите полное место рождения заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.birthPlaceFull', 'Длина полного места рождения заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.birthPlaceFull', 'Полное место рождения заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.birthPlaceRus', 'Укажите место рождения заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.birthPlaceRus', 'Длина места рождения заявителя превышает 35 символов'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG_SUM.applicant.birthPlaceRus',
    'Суммарная длина мест рождения заявителя на кириллице и на латинице превышает 38 символов',
  ],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.birthPlaceRus', 'Место рождения заявителя содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeatures.BIRTHPLACE_MISMATCH.applicant.birthPlaceRus',
    'Место рождения и/или Birthplace отсутствует в справочнике, либо не соответствует дате рождения',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.birthPlaceLat', 'Укажите место рождения заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.birthPlaceLat', 'Длина места рождения заявителя превышает 35 символов'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG_SUM.applicant.birthPlaceLat',
    'Суммарная длина мест рождения заявителя на кириллице и на латинице превышает 38 символов',
  ],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.birthPlaceLat', 'Место рождения заявителя содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeatures.BIRTHPLACE_MISMATCH.applicant.birthPlaceLat',
    'Место рождения и/или Birthplace отсутствует в справочнике, либо не соответствует дате рождения',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.secondNationality.value', 'Укажите второе гражданство заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.secondNationality.value', 'Длина второго гражданства заявителя превышает 255 символов'],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.secondNationality.value',
    'Второе гражданство заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.permAddress.index', 'Укажите индекс в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.permAddress.index', 'Длина индекса в адресе заявителя превышает 20 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.permAddress.index', 'Индекс в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.permAddress.country', 'Укажите страну в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.permAddress.country', 'Длина страны в адресе заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.permAddress.country', 'Страна в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.permAddress.admDivision.value', 'Укажите субъект федерации в адресе заявителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.permAddress.admDivision.value',
    'Длина субъекта федерации в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.permAddress.admDivision.value',
    'Субъект федерации в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.permAddress.settlement', 'Укажите населённый пункт в адресе заявителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.permAddress.settlement',
    'Длина населённого пункта в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.permAddress.settlement',
    'Населённый пункт в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.permAddress.street.value', 'Укажите улицу в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.permAddress.street.value', 'Длина улицы в адресе заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.permAddress.street.value', 'Удица в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.permAddress.building.value', 'Укажите дом в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.permAddress.building.value', 'Длина дома в адресе заявителя превышает 20 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.permAddress.building.value', 'Дом в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.permAddress.housing.value', 'Укажите корпус в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.permAddress.housing.value', 'Длина корпуса в адресе заявителя превышает 20 символов'],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.permAddress.housing.value',
    'Корпус в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.permAddress.structure.value', 'Укажите строение в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.permAddress.structure.value', 'Длина строения в адресе заявителя превышает 20 символов'],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.permAddress.structure.value',
    'Строение в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.permAddress.flat.value', 'Укажите квартиру в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.permAddress.flat.value', 'Длина квартиры в адресе заявителя превышает 20 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.permAddress.flat.value', 'Квартира в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.permAddress.phone', 'Укажите телефон в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.permAddress.phone', 'Длина телефона в адресе заявителя превышает 50 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.permAddress.phone', 'Телефон в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.tempAddress.index', 'Укажите индекс в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.tempAddress.index', 'Длина индекса в адресе заявителя превышает 20 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.tempAddress.index', 'Индекс в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.tempAddress.country', 'Укажите страну в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.tempAddress.country', 'Длина страны в адресе заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.tempAddress.country', 'Страна в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.tempAddress.admDivision.value', 'Укажите субъект федерации в адресе заявителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.tempAddress.admDivision.value',
    'Длина субъекта федерации в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.tempAddress.admDivision.value',
    'Субъект федерации в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.tempAddress.settlement', 'Укажите населённый пункт в адресе заявителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.tempAddress.settlement',
    'Длина населённого пункта в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.tempAddress.settlement',
    'Населённый пункт в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.tempAddress.street.value', 'Укажите улицу в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.tempAddress.street.value', 'Длина улицы в адресе заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.tempAddress.street.value', 'Удица в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.tempAddress.building.value', 'Укажите дом в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.tempAddress.building.value', 'Длина дома в адресе заявителя превышает 20 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.tempAddress.building.value', 'Дом в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.tempAddress.housing.value', 'Укажите корпус в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.tempAddress.housing.value', 'Длина корпуса в адресе заявителя превышает 20 символов'],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.tempAddress.housing.value',
    'Корпус в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.tempAddress.structure.value', 'Укажите строение в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.tempAddress.structure.value', 'Длина строения в адресе заявителя превышает 20 символов'],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.tempAddress.structure.value',
    'Строение в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.tempAddress.flat.value', 'Укажите квартиру в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.tempAddress.flat.value', 'Длина квартиры в адресе заявителя превышает 20 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.tempAddress.flat.value', 'Квартира в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.tempAddress.phone', 'Укажите телефон в адресе заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.tempAddress.phone', 'Длина телефона в адресе заявителя превышает 50 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.tempAddress.phone', 'Телефон в адресе заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.activeFPassports.p1.series', 'Укажите серию действующего ОЗП'],
  ['VALIDATION.RequestFeatures.TOO_SHORT.applicant.activeFPassports.p1.series', 'Длина серии действующего ОЗП менее 2 символов'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.activeFPassports.p1.series', 'Длина серии действующего ОЗП превышает 2 символа'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.activeFPassports.p1.series', 'Серия действующего ОЗП содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.FOREIGN_PASSPORT_NOT_COMMON.applicant.activeFPassports.p1.series', 'Серия действующего ОЗП неверна'],
  [
    'VALIDATION.RequestFeatures.FOREIGN_PASSPORT_UNKNOWN_SERIES.applicant.activeFPassports.p1.series',
    'Указанный паспорт имеет неизвестную серию',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.activeFPassports.p1.number', 'Укажите номер действующего ОЗП'],
  ['VALIDATION.RequestFeatures.TOO_SHORT.applicant.activeFPassports.p1.number', 'Длина номера действующего ОЗП менее 7 символов'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.activeFPassports.p1.number', 'Длина номера действующего ОЗП превышает 7 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.activeFPassports.p1.number', 'Номер действующего ОЗП содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.activeFPassports.p1.issuer', 'Укажите наименование органа, выдавшего действующий ОЗП'],
  [
    'VALIDATION.RequestFeatures.TOO_SHORT.applicant.activeFPassports.p1.issuer',
    'Длина наименования органа, выдавшего действующий ОЗП, менее 2 символов',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.activeFPassports.p1.issuer',
    'Длина наименования органа, выдавшего действующий ОЗП, превышает 2 символа',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.activeFPassports.p1.issuer',
    'Наименование органа, выдавшего действующий ОЗП, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.activeFPassports.p1.issueDate.value', 'Укажите дату выдачи действующего ОЗП'],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.applicant.activeFPassports.p1.issueDate.value',
    'Дата выдачи действующего ОЗП меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.activeFPassports.p1.issueDate.value',
    'Недопустимая дата выдачи действующего ОЗП',
  ],
  [
    'VALIDATION.RequestFeatures.FOREIGN_PASSPORT_EXPIRED.applicant.activeFPassports.p1.issueDate.value',
    'Срок действия ОЗП истёк (согласно его серии и дате выдачи)',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.activeFPassports.p2.series', 'Укажите серию действующего ОЗП'],
  ['VALIDATION.RequestFeatures.TOO_SHORT.applicant.activeFPassports.p2.series', 'Длина серии действующего ОЗП менее 2 символов'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.activeFPassports.p2.series', 'Длина серии действующего ОЗП превышает 2 символа'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.activeFPassports.p2.series', 'Серия действующего ОЗП содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.FOREIGN_PASSPORT_NOT_COMMON.applicant.activeFPassports.p2.series', 'Серия действующего ОЗП неверна'],
  [
    'VALIDATION.RequestFeatures.FOREIGN_PASSPORT_UNKNOWN_SERIES.applicant.activeFPassports.p2.series',
    'Указанный паспорт имеет неизвестную серию',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.activeFPassports.p2.number', 'Укажите номер действующего ОЗП'],
  ['VALIDATION.RequestFeatures.TOO_SHORT.applicant.activeFPassports.p2.number', 'Длина номера действующего ОЗП менее 7 символов'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.activeFPassports.p2.number', 'Длина номера действующего ОЗП превышает 7 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.activeFPassports.p2.number', 'Номер действующего ОЗП содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.activeFPassports.p2.issuer', 'Укажите наименование органа, выдавшего действующий ОЗП'],
  [
    'VALIDATION.RequestFeatures.TOO_SHORT.applicant.activeFPassports.p2.issuer',
    'Длина наименования органа, выдавшего действующий ОЗП, менее 2 символов',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.activeFPassports.p2.issuer',
    'Длина наименования органа, выдавшего действующий ОЗП, превышает 2 символа',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.activeFPassports.p2.issuer',
    'Наименование органа, выдавшего действующий ОЗП, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.activeFPassports.p2.issueDate.value', 'Укажите дату выдачи действующего ОЗП'],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.applicant.activeFPassports.p2.issueDate.value',
    'Дата выдачи действующего ОЗП меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.activeFPassports.p2.issueDate.value',
    'Недопустимая дата выдачи действующего ОЗП',
  ],
  [
    'VALIDATION.RequestFeatures.FOREIGN_PASSPORT_EXPIRED.applicant.activeFPassports.p2.issueDate.value',
    'Срок действия ОЗП истёк (согласно его серии и дате выдачи)',
  ],
  [
    'VALIDATION.RequestFeatures.FOREIGN_PASSPORT_NOT_CANCELED.applicant.activeFPassports',
    'Отметьте хотя бы один ОЗП как подлежащий к аннулированию',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.jobRecords.position', 'Укажите должность в трудовой деятельности заявителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.jobRecords.position',
    'Длина должности в трудовой деятельности заявителя превышает 5530 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.jobRecords.position',
    'Должность в трудовой деятельности заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.jobRecords.address', 'Укажите адрес в трудовой деятельности заявителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.jobRecords.address',
    'Длина адреса в трудовой деятельности заявителя превышает 5530 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.jobRecords.address',
    'Адрес в трудовой деятельности заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.jobRecords.from.value', 'Укажите дату начала работы в трудовой деятельности заявителя'],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.applicant.jobRecords.from.value',
    'Дата начала работы в трудовой деятельности заявителя меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.jobRecords.from.value',
    'Недопустимая дата начала работы в трудовой деятельности заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.jobRecords.to.value',
    'Укажите дату окончания работы в трудовой деятельности заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.applicant.jobRecords.to.value',
    'Дата окончания работы в трудовой деятельности заявителя меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_FROM.applicant.jobRecords.to.value',
    'Дата окончания работы в трудовой деятельности заявителя меньше соответствующей даты начала работы',
  ],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.jobRecords.to.value',
    'Недопустимая дата окончания работы в трудовой деятельности заявителя',
  ],
  ['VALIDATION.RequestFeatures.JOB_LIST_IS_EMPTY.applicant.jobRecords', 'Заполните трудовую деятельность заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.jobManDate.value', 'Укажите дату заверения трудовой деятельности заявителя'],
  [
    'VALIDATION.RequestFeatures.DOCUMENT_AGE_GREATER_THAN_2.applicant.jobManDate.value',
    'Трудовая деятельность заявителя заверена более двух лет назад',
  ],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.jobManDate.value',
    'Недопустимая дата заверения трудовой деятельности заявителя',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.jobManName', 'Укажите лицо, заверившее трудовую деятельность заявителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.applicant.jobManName', 'Недопустимая длина лица, заверившего трудовую деятельность заявителя'],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.jobManName',
    'Лицо, заверившее трудовую деятельность заявителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.hrManager.position',
    'Укажите должность лица, заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.hrManager.position',
    'Недопустимая длина должности заверившего трудовую деятельность заявителя',
  ],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.hrManager.position', 'Должность заверившего лица содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.hrManager.fullName.firstName',
    'Укажите имя лица, заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.hrManager.fullName.firstName',
    'Недопустимая длина имени заверившего трудовую деятельность заявителя',
  ],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.hrManager.fullName.firstName', 'Имя заверившего лица содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.hrManager.fullName.lastName',
    'Укажите фамилию лица, заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.hrManager.fullName.lastName',
    'Недопустимая длина фамилии заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.hrManager.fullName.lastName',
    'Фамилия заверившего лица содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.hrManager.fullName.middleName.value',
    'Укажите отчество лица, заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.hrManager.fullName.middleName.value',
    'Недопустимая длина отчества заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.hrManager.fullName.middleName.value',
    'Отчество заверившего лица содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.applicant.hrManager.phone',
    'Укажите телефон лица, заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.hrManager.phone',
    'Недопустимая длина телефона заверившего трудовую деятельность заявителя',
  ],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.hrManager.phone', 'Телефон заверившего лица содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeatures.REQUIRED.applicant.identityDocument.type.value',
    'Выберите тип документа, удостоверяющего личность заявителя',
  ],
  ['VALIDATION.RequestFeatures.WARN.applicant.identityDocument.series', 'Укажите серию документа, удостоверяющего личность заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.identityDocument.series', 'Укажите серию документа, удостоверяющего личность заявителя'],
  [
    'VALIDATION.RequestFeatures.TOO_SHORT.applicant.identityDocument.series',
    'Недопустимая длина серии документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.identityDocument.series',
    'Недопустимая длина серии документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.identityDocument.series',
    'Серия документа, удостоверяющего личность заявителя, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.identityDocument.number', 'Укажите номер документа, удостоверяющего личность заявителя'],
  [
    'VALIDATION.RequestFeatures.TOO_SHORT.applicant.identityDocument.number',
    'Недопустимая длина номера документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.identityDocument.number',
    'Недопустимая длина номера документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.identityDocument.number',
    'Номер документа, удостоверяющего личность заявителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.applicant.identityDocument.issuer',
    'Укажите наименование органа, выдавшего документ, удостоверяющий личность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_SHORT.applicant.identityDocument.issuer',
    'Недопустимая длина наименования органа, выдавшего документ, удостоверяющий личность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.applicant.identityDocument.issuer',
    'Недопустимая длина наименования органа, выдавшего документ, удостоверяющий личность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.applicant.identityDocument.issuer',
    'Наименование органа, выдавшего документ, удостоверяющий личность заявителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.applicant.identityDocument.issueDate.value',
    'Укажите дату выдачи документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.applicant.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность заявителя, меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_YEAR_OF_1997.applicant.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность заявителя, меньше 1997 года',
  ],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_AGE_OF_14.applicant.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность заявителя, меньше даты наступления 14-летия заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.RUSSIAN_PASSPORT_EXPIRED_20.applicant.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность заявителя, недействителен в связи с наступлением 20-летия заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.RUSSIAN_PASSPORT_EXPIRED_45.applicant.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность заявителя, недействителен в связи с наступлением 45-летия заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.IDENTITY_DOCUMENT_MISMATCH.applicant.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность заявителя, недействителен в связи со сменой ФИО заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.identityDocument.issueDate.value',
    'Недопустимая дата выдачи документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.APPLICANT_IDENITY_NOT_CONFIRMED.applicant.identityDocument',
    'Личность заявителя не удостоверена (паспортом РФ с 14 лет, свидетельством о рождении до 14 лет)',
  ],
  [
    'VALIDATION.RequestFeatures.APPLICANT_IDENITY_NOT_CONFIRMED_RKZU_SITE.applicant.identityDocument',
    'Личность заявителя не удостоверена (паспортом РФ с 14 лет, свидетельством о рождении до 14 лет, действующим ОЗП)',
  ],
  [
    'VALIDATION.RequestFeatures.APPLICANT_IDENITY_NOT_CONFIRMED_RKZU.applicant.identityDocument',
    'Личность заявителя не удостоверена (паспортом РФ с 14 лет, свидетельством о рождении до 14 лет, действующим ОЗП, подтверждением гражданства)',
  ],
  ['VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.chipPhoto.scanned', 'Отсутствует цв. фотография заявителя'],
  ['VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.printPhoto.scanned', 'Отсутствует ч/б фотография заявителя'],
  ['VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.applicant.signature.scanned', 'Отсутствует подпись заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.fingerprints.hash', 'Отсутствуют отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.fingerprints.cert', 'Отсутствуют отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.fingerprints.ekey', 'Отсутствуют отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.fingerprints.digestURN', 'Отсутствуют отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.applicant.fingerprints.transportURN', 'Отсутствуют отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.representative.gender.value', 'Укажите пол законного представителя'],
  ['VALIDATION.RequestFeatures.REQUIRED.representative.personIdentity.fullName.lastName', 'Укажите фамилию законного представителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.representative.personIdentity.fullName.lastName',
    'Длина фамилии законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.personIdentity.fullName.lastName',
    'Фамилия законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.WARN_FORMAT.representative.personIdentity.fullName.lastName',
    'Фамилия законного представителя содержит римские цифры',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.representative.personIdentity.fullName.firstName', 'Укажите имя законного представителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.representative.personIdentity.fullName.firstName',
    'Длина имени законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.personIdentity.fullName.firstName',
    'Имя законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.WARN_FORMAT.representative.personIdentity.fullName.firstName',
    'Имя законного представителя содержит римские цифры',
  ],
  [
    'VALIDATION.RequestFeatures.GENDER_MISMATCH.representative.personIdentity.fullName.firstName',
    'Имя законного представителя не соответствует полу законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.representative.personIdentity.fullName.middleName.value',
    'Укажите отчество законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.representative.personIdentity.fullName.middleName.value',
    'Длина отчества законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.personIdentity.fullName.middleName.value',
    'Отчество законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.WARN_FORMAT.representative.personIdentity.fullName.middleName.value',
    'Отчество законного представителя содержит римские цифры',
  ],
  [
    'VALIDATION.RequestFeatures.GENDER_MISMATCH.representative.personIdentity.fullName.middleName.value',
    'Отчество законного представителя не соответствует полу законного представителя',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.representative.personIdentity.birthDate.value', 'Укажите дату рождения законного представителя'],
  [
    'VALIDATION.RequestFeatures.PERSON_AGE_LESS_THAN_16.representative.personIdentity.birthDate.value',
    'Возраст законного представителя меньше 16 лет',
  ],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.representative.personIdentity.birthDate.value',
    'Недопустимая дата рождения законного представителя',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.representative.birthPlace', 'Укажите место рождения законного представителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.representative.birthPlace', 'Длина места рождения законного представителя превышает 255 символов'],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.birthPlace',
    'Место рождения законного представителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.representative.address.text', 'Укажите адрес законного представителя'],
  ['VALIDATION.RequestFeatures.TOO_LONG.representative.address.text', 'Длина адреса законного представителя превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.representative.address.text', 'Адрес законного представителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.representative.nameChanges.lastName', 'Укажите предыдущую фамилию законного представителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.representative.nameChanges.lastName',
    'Длина предыдущей фамилии законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.nameChanges.lastName',
    'Предыдущая фамилия законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.WARN_FORMAT.representative.nameChanges.lastName',
    'Предыдущая фамилия законного представителя содержит римские цифры или цифры',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.representative.nameChanges.firstName', 'Укажите предыдущее имя законного представителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.representative.nameChanges.firstName',
    'Длина предыдущего имени законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.nameChanges.firstName',
    'Предыдущее имя законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.WARN_FORMAT.representative.nameChanges.firstName',
    'Предыдущее имя законного представителя содержит римские цифры или цифры',
  ],
  [
    'VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.representative.nameChanges.middleName.value',
    'Укажите предыдущее отчество законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.representative.nameChanges.middleName.value',
    'Длина предыдущего отчества законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.nameChanges.middleName.value',
    'Предыдущее отчество законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.WARN_FORMAT.representative.nameChanges.middleName.value',
    'Предыдущее отчество законного представителя содержит римские цифры или цифры',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.representative.nameChanges.year.value', 'Укажите год смены ФИО законного представителя'],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.representative.nameChanges.year.value',
    'Год смены ФИО законного представителя меньше даты рождения законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.representative.nameChanges.year.value',
    'Недопустимый год смены ФИО законного представителя',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.representative.nameChanges.location', 'Укажите место смены ФИО законного представителя'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.representative.nameChanges.location',
    'Длина места смены ФИО законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.nameChanges.location',
    'Место смены ФИО законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.MATCH.representative.nameChanges',
    'Последняя запись о смене ФИО законного представителя совпадает с ФИО законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.representative.identityDocument.type.value',
    'Выберите тип документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.representative.identityDocument.series',
    'Укажите серию документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_SHORT.representative.identityDocument.series',
    'Недопустимая длина серии документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.representative.identityDocument.series',
    'Недопустимая длина серии документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.identityDocument.series',
    'Серия документа, удостоверяющего личность законного представителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.representative.identityDocument.number',
    'Укажите номер документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_SHORT.representative.identityDocument.number',
    'Недопустимая длина номера документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.representative.identityDocument.number',
    'Недопустимая длина номера документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.identityDocument.number',
    'Номер документа, удостоверяющего личность законного представителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.representative.identityDocument.issuer',
    'Укажите наименование органа, выдавшего документ, удостоверяющий личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_SHORT.representative.identityDocument.issuer',
    'Недопустимая длина наименования органа, выдавшего документ, удостоверяющий личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.representative.identityDocument.issuer',
    'Недопустимая длина наименования органа, выдавшего документ, удостоверяющий личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.representative.identityDocument.issuer',
    'Наименование органа, выдавшего документ, удостоверяющий личность законного представителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.representative.identityDocument.issueDate.value',
    'Укажите дату выдачи документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.representative.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность законного представителя, меньше даты рождения законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_YEAR_OF_1997.representative.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность законного представителя, меньше 1997 года',
  ],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_AGE_OF_14.representative.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность законного представителя, меньше даты наступления 14-летия законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.RUSSIAN_PASSPORT_EXPIRED_20.representative.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность законного представителя, недействителен в связи с наступлением 20-летия законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.RUSSIAN_PASSPORT_EXPIRED_45.representative.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность законного представителя, недействителен в связи с наступлением 45-летия законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.IDENTITY_DOCUMENT_MISMATCH.representative.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность законного представителя, недействителен в связи со сменой ФИО законного представителя',
  ],
  [
    'VALIDATION.RequestFeatures.FOREIGN_PASSPORT_EXPIRED.representative.identityDocument.issueDate.value',
    'Срок действия документа, удостоверяющего личность законного представителя, истёк (согласно его серии и дате выдачи)',
  ],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.representative.identityDocument.issueDate.value',
    'Недопустимая дата выдачи документа, удостоверяющего личность законного представителя',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.goal.value', 'Укажите цель получения паспорта'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.residenceCountry', 'Укажите наименование страны проживания'],
  ['VALIDATION.RequestFeatures.TOO_LONG.residenceCountry', 'Длина наименования страны проживания превышает 35 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.residenceCountry', 'Наименование страны проживания содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.cause.value', 'Укажите тип получения паспорта'],
  ['VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.cause.value', 'Недопустимый тип получения паспорта'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.secretAccess.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.TOO_LONG.secretAccess.value', 'Длина ограничения выезда превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.secretAccess.value', 'Ограничение выезда содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.departureRestrictions.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.TOO_LONG.departureRestrictions.value', 'Длина ограничения выезда превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.departureRestrictions.value', 'Ограничение выезда содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.militaryService.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.TOO_LONG.militaryService.value', 'Длина ограничения выезда превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.militaryService.value', 'Ограничение выезда содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.conviction.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.TOO_LONG.conviction.value', 'Длина ограничения выезда превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.conviction.value', 'Ограничение выезда содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.legalObligations.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.TOO_LONG.legalObligations.value', 'Длина ограничения выезда превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.legalObligations.value', 'Ограничение выезда содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.dipServiceControlData.dutyOrganization', 'Укажите наименование организации'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.dipServiceControlData.dutyOrganization', 'Укажите наименование организации'],
  ['VALIDATION.RequestFeatures.TOO_LONG.dipServiceControlData.dutyOrganization', 'Длина наименования организации превышает 255 символов'],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.dipServiceControlData.dutyOrganization',
    'Наименование организации содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.dipServiceControlData.dutyPosition', 'Укажите должность и место работы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.dipServiceControlData.dutyPosition', 'Укажите должность и место работы'],
  ['VALIDATION.RequestFeatures.TOO_LONG.dipServiceControlData.dutyPosition', 'Длина должности и места работы превышает 255 символов'],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.dipServiceControlData.dutyPosition',
    'Поле должности и места работы содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.dipServiceControlData.dutyDuration', 'Укажите срок командировки'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.dipServiceControlData.dutyDuration', 'Укажите срок командировки'],
  ['VALIDATION.RequestFeatures.TOO_LONG.dipServiceControlData.dutyDuration', 'Длина срока командировки превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.dipServiceControlData.dutyDuration', 'Поле срока командировки содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.dipServiceControlData.dutyCountry', 'Укажите страну командировки'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.dipServiceControlData.dutyCountry', 'Укажите страну командировки'],
  ['VALIDATION.RequestFeatures.TOO_LONG.dipServiceControlData.dutyCountry', 'Длина страны командировки превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.dipServiceControlData.dutyCountry', 'Страна командировки содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.dipServiceControlData.secretAware.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.dipServiceControlData.secretAware.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.TOO_LONG.dipServiceControlData.secretAware.value', 'Длина поля превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.dipServiceControlData.secretAware.value', 'Поле содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.dipServiceControlData.secretAdmitted.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.dipServiceControlData.secretAdmitted.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.TOO_LONG.dipServiceControlData.secretAdmitted.value', 'Длина поля превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.dipServiceControlData.secretAdmitted.value', 'Поле содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.dipServiceControlData.contracts.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.dipServiceControlData.contracts.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.TOO_LONG.dipServiceControlData.contracts.value', 'Длина поля превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.dipServiceControlData.contracts.value', 'Поле содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.dipServiceControlData.trips.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.dipServiceControlData.trips.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeatures.TOO_LONG.dipServiceControlData.trips.value', 'Длина поля превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.dipServiceControlData.trips.value', 'Поле содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.mailing.addressRus', 'Укажите адрес почтового отправления'],
  ['VALIDATION.RequestFeatures.TOO_LONG.mailing.addressRus', 'Длина адреса почтового отправления превышает 1024 символа'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.mailing.addressRus', 'Адрес почтового отправления содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.mailing.addressLat', 'Укажите адрес почтового отправления'],
  ['VALIDATION.RequestFeatures.TOO_LONG.mailing.addressLat', 'Длина адреса почтового отправления превышает 1024 символа'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.mailing.addressLat', 'Адрес почтового отправления содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.citizenshipCertificate.number', 'Укажите номер заключения о наличии гражданства'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.citizenshipCertificate.number',
    'Длина номера заключения о наличии гражданства превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.citizenshipCertificate.number',
    'Номер заключения о наличии гражданства содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.citizenshipCertificate.date.value', 'Укажите дату заключения о наличии гражданства'],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.citizenshipCertificate.date.value',
    'Дата заключения о наличии гражданства меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.DOCUMENT_AGE_GREATER_THAN_1.citizenshipCertificate.date.value',
    'Заключение о наличии гражданства оформлено более года назад',
  ],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.citizenshipCertificate.date.value',
    'Недопустимое значение даты заключения о наличии гражданства',
  ],
  [
    'VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.citizenshipCertificate.officerPost',
    'Укажите должность заверителя заключения о наличии гражданства',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.citizenshipCertificate.officerPost',
    'Длина должности заверителя заключения о наличии гражданства превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.citizenshipCertificate.officerPost',
    'Должность заверителя заключения о наличии гражданства содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.citizenshipCertificate.officerName',
    'Укажите ФИО заверителя заключения о наличии гражданства',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.citizenshipCertificate.officerName',
    'Длина ФИО заверителя заключения о наличии гражданства превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.citizenshipCertificate.officerName',
    'ФИО заверителя заключения о наличии гражданства содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.citizenshipCertificate.testimony', 'Укажите текст заключения о наличии гражданства'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.citizenshipCertificate.testimony',
    'Длина текста заключения о наличии гражданства превышает 4096 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.citizenshipCertificate.testimony',
    'Текст заключения о наличии гражданства содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.presidentEdict.number', 'Укажите номер указа о приёме в гражданство'],
  ['VALIDATION.RequestFeatures.TOO_LONG.presidentEdict.number', 'Длина номера указа о приёме в гражданство превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.presidentEdict.number', 'Номер указа о приёме в гражданство содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.presidentEdict.date.value', 'Укажите дату указа о приёме в гражданство'],
  ['VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.presidentEdict.date.value', 'Недопустимое значение даты указа о приёме в гражданство'],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.presidentEdict.date.value',
    'Дата указа о приёме в гражданство меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.DOCUMENT_AGE_GREATER_THAN_3.presidentEdict.date.value',
    'Указ о приёме в гражданство оформлен более 3-х месяцев назад',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.citizenshipDecision.number', 'Укажите номер заявления о вступлении в гражданство'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.citizenshipDecision.number',
    'Длина номера заявления о вступлении в гражданство превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.citizenshipDecision.number',
    'Номер заявления о вступлении в гражданство содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.citizenshipDecision.date.value', 'Укажите дату решения о вступлении в гражданство'],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.citizenshipDecision.date.value',
    'Недопустимое значение даты решения о вступлении в гражданство',
  ],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.citizenshipDecision.date.value',
    'Дата решения о вступлении в гражданство меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.DOCUMENT_AGE_GREATER_THAN_3.citizenshipDecision.date.value',
    'Решение о вступлении в гражданство оформлено более 3-х месяцев назад',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.citizenshipDecision.officerPost',
    'Укажите должность руководителя, принявшего решение о вступлении в гражданство',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.citizenshipDecision.officerPost',
    'Длина должности руководителя, принявшего решение о вступлении в гражданство, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.citizenshipDecision.officerPost',
    'Должность руководителя, принявшего решение о вступлении в гражданство, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.citizenshipDecision.officerName',
    'Укажите ФИО руководителя, принявшего решение о вступлении в гражданство',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.citizenshipDecision.officerName',
    'Длина ФИО руководителя, принявшего решение о вступлении в гражданство, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.citizenshipDecision.officerName',
    'ФИО руководителя, принявшего решение о вступлении в гражданство, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.citizenshipDecision.article',
    'Укажите статью, на основании которой было принято решение о вступлении в гражданство',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.citizenshipDecision.article',
    'Длина статьи, на основании которой было принято решение о вступлении в гражданство, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.citizenshipDecision.article',
    'Статья, на основании которой было принято решение о вступлении в гражданство, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.soldierPermission.number', 'Укажите номер справки военнослужащего'],
  ['VALIDATION.RequestFeatures.TOO_LONG.soldierPermission.number', 'Длина номера справки военнослужащего превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.soldierPermission.number', 'Номер справки военнослужащего содержит недопустимые символы'],
  ['VALIDATION.RequestFeatures.REQUIRED.soldierPermission.date.value', 'Укажите дату справки военнослужащего'],
  ['VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.soldierPermission.date.value', 'Недопустимое значение даты справки военнослужащего'],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.soldierPermission.date.value',
    'Дата справки военнослужащего меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.soldierPermission.signerPost',
    'Укажите должность сотрудника, подписавшего справку военнослужащего',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.soldierPermission.signerPost',
    'Длина должности сотрудника, подписавшего справку военнослужащего, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.soldierPermission.signerPost',
    'Должность сотрудника, подписавшего справку военнослужащего, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.soldierPermission.signerName', 'Укажите ФИО сотрудника, подписавшего справку военнослужащего'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.soldierPermission.signerName',
    'Длина ФИО сотрудника, подписавшего справку военнослужащего, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.soldierPermission.signerName',
    'ФИО сотрудника, подписавшего справку военнослужащего, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.soldierPermission.agreementNumber', 'Укажите номер согласования справки военнослужащего в ФСБ'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.soldierPermission.agreementNumber',
    'Длина номера согласования справки военнослужащего в ФСБ превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.soldierPermission.agreementNumber',
    'Номер согласования справки военнослужащего в ФСБ содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.soldierPermission.agreementDate.value', 'Укажите дату согласования справки военнослужащего в ФСБ'],
  [
    'VALIDATION.RequestFeatures.NOT_ALLOWED_VALUE.soldierPermission.agreementDate.value',
    'Недопустимое значение даты согласования справки военнослужащего в ФСБ',
  ],
  [
    'VALIDATION.RequestFeatures.LESS_THAN_BIRTHDATE.soldierPermission.agreementDate.value',
    'Дата согласования справки военнослужащего в ФСБ меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeatures.REQUIRED.soldierPermission.deciderName',
    'Укажите ФИО сотрудника, принявшего решение о выдаче паспорта военнослужащему',
  ],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.soldierPermission.deciderName',
    'Длина ФИО сотрудника, принявшего решение о выдаче паспорта военнослужащему, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.soldierPermission.deciderName',
    'ФИО сотрудника, принявшего решение о выдаче паспорта военнослужащему, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.REQUIRED.soldierPermission.militaryUnit', 'Укажите номер военной части военнослужащего'],
  [
    'VALIDATION.RequestFeatures.TOO_LONG.soldierPermission.militaryUnit',
    'Длина номера военной части военнослужащего превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeatures.WRONG_FORMAT.soldierPermission.militaryUnit',
    'Номер военной части военнослужащего содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeatures.CANNOT_BE_EMPTY.receptionUser', 'Укажите ФИО сотрудника, принявшего заявление'],
  ['VALIDATION.RequestFeatures.REQUIRED.receptionUser', 'Укажите ФИО сотрудника, принявшего заявление'],
  ['VALIDATION.RequestFeatures.TOO_LONG.receptionUser', 'Длина ФИО сотрудника, принявшего заявление, превышает 255 символов'],
  ['VALIDATION.RequestFeatures.WRONG_FORMAT.receptionUser', 'ФИО сотрудника, принявшего заявление, содержит недопустимые символы'],

  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.gender.value', 'Укажите пол заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.personIdentity.fullName.lastName', 'Укажите фамилию заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.personIdentity.fullName.lastName', 'Длина фамилии заявителя превышает 34 символа'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.personIdentity.fullName.lastName',
    'Фамилия заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.WARN_FORMAT.applicant.personIdentity.fullName.lastName', 'Фамилия заявителя содержит римские цифры'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.personIdentity.fullName.firstName', 'Укажите имя заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.personIdentity.fullName.firstName', 'Длина имени заявителя превышает 40 символов'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG_SUM.applicant.personIdentity.fullName.firstName',
    'Суммарная длина имени и отчества заявителя превышает 39 символов',
  ],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.personIdentity.fullName.firstName', 'Имя заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.WARN_FORMAT.applicant.personIdentity.fullName.firstName', 'Имя заявителя содержит римские цифры'],
  [
    'VALIDATION.RequestFeaturesV2.GENDER_MISMATCH.applicant.personIdentity.fullName.firstName',
    'Имя заявителя не соответствует полу заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.personIdentity.fullName.middleName.value', 'Укажите отчество заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.personIdentity.fullName.middleName.value',
    'Длина отчества заявителя превышает 38 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG_SUM.applicant.personIdentity.fullName.middleName.value',
    'Суммарная длина имени и отчества заявителя превышает 39 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.personIdentity.fullName.middleName.value',
    'Отчество заявителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN_FORMAT.applicant.personIdentity.fullName.middleName.value',
    'Отчество заявителя содержит римские цифры',
  ],
  [
    'VALIDATION.RequestFeaturesV2.GENDER_MISMATCH.applicant.personIdentity.fullName.middleName.value',
    'Отчество заявителя не соответствует полу заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.MIDDLE_NAME_STUBS.applicant.personIdentity.fullName.middleName.value',
    `Отчество не может состоять только из символов "." или "-". Если у Вас отсутствует отчество, оставьте поле пустым и отметьте признак "Нет" для отчества.`,
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.personIdentity.birthDate.value', 'Укажите дату рождения заявителя'],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.personIdentity.birthDate.value', 'Недопустимая дата рождения заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.nameChanges.lastName', 'Укажите предыдущую фамилию заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.nameChanges.lastName', 'Длина предыдущей фамилии заявителя превышает 255 символов'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.nameChanges.lastName',
    'Предыдущая фамилия заявителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN_FORMAT.applicant.nameChanges.lastName',
    'Предыдущая фамилия заявителя содержит арабские или римские цифры',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.nameChanges.firstName', 'Укажите предыдущее имя заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.nameChanges.firstName', 'Длина предыдущего имени заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.nameChanges.firstName', 'Предыдущее имя заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.WARN_FORMAT.applicant.nameChanges.firstName', 'Предыдущее имя заявителя содержит арабские или римские цифры'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.nameChanges.middleName.value', 'Укажите предыдущее отчество заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.nameChanges.middleName.value',
    'Длина предыдущего отчества заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.nameChanges.middleName.value',
    'Предыдущее отчество заявителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN_FORMAT.applicant.nameChanges.middleName.value',
    'Предыдущее отчество заявителя содержит арабские или римские цифры',
  ],
  [
    'VALIDATION.RequestFeaturesV2.MIDDLE_NAME_STUBS.applicant.nameChanges.middleName.value',
    `Отчество не может состоять только из символов "." или "-". Если у Вас отсутствует отчество, оставьте поле пустым и отметьте признак "Нет" для отчества.`,
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.nameChanges.year.value', 'Укажите дату смены ФИО заявителя'],
  ['VALIDATION.RequestFeaturesV2.FORMAT_ERROR.applicant.nameChanges.year.value', 'Требуется указать полную дату смены ФИО'],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.applicant.nameChanges.year.value',
    'Дата смены ФИО заявителя меньше даты рождения заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.nameChanges.year.value', 'Дата не может быть больше текущей даты'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.nameChanges.location', 'Укажите место смены ФИО заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.nameChanges.location', 'Длина места смены ФИО заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.nameChanges.location', 'Место смены ФИО заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.MATCH.applicant.nameChanges', 'Последняя запись о смене ФИО заявителя совпадает с ФИО заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.lastNameLat', 'Укажите фамилию заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.lastNameLat', 'Длина фамилии заявителя превышает 36 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.lastNameLat', 'Фамилия заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.firstNameLat', 'Укажите имя заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.firstNameLat', 'Длина имени заявителя превышает 42 символа'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.firstNameLat', 'Имя заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.birthPlaceFull', 'Укажите полное место рождения заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.birthPlaceFull', 'Длина полного места рождения заявителя превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.birthPlaceFull', 'Полное место рождения заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.birthPlaceRus', 'Укажите место рождения заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.BIRTHPLACE_INSUFFICIENT.applicant.birthPlaceRus',
    'Недопустимое значение в поле "Место рождения". Если Вы родились на территории РФ, то укажите наименование субъекта РФ, в котором Вы родились, или административного центра субъекта РФ, если Вы родились в данном центре.',
  ],
  [
    'VALIDATION.RequestFeaturesV2.BIRTHPLACE_INSUFFICIENT.applicant.birthPlaceFull',
    'Недопустимое значение в поле "Полное место рождения", данное поле должно содержать наименование Вашего места рождения, указанное во внутреннем паспорте или свидетельстве о рождении. Например: «ЗАЙЦЕВО, БЕЛЕВСКИЙ РАЙОН, ТУЛЬСКАЯ ОБЛАСТЬ, РОССИЯ», «БЕЛАРУСЬ, МОГИЛЁВСКАЯ ОБЛАСТЬ, МОГИЛЁВ».',
  ],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.birthPlaceRus', 'Длина места рождения заявителя превышает 35 символов'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG_SUM.applicant.birthPlaceRus',
    'Суммарная длина мест рождения заявителя на кириллице и на латинице превышает 38 символов',
  ],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.birthPlaceRus', 'Место рождения заявителя содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeaturesV2.BIRTHPLACE_MISMATCH.applicant.birthPlaceRus',
    'Место рождения и/или Birthplace отсутствует в справочнике, либо не соответствует дате рождения',
  ],
  [
    'VALIDATION.RequestFeaturesV2.BIRTHPLACE_MISMATCH.applicant.birthPlaceFull',
    'Место рождения и/или Birthplace отсутствует в справочнике, либо не соответствует дате рождения',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.birthPlaceLat', 'Укажите место рождения заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.birthPlaceLat', 'Длина места рождения заявителя превышает 35 символов'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG_SUM.applicant.birthPlaceLat',
    'Суммарная длина мест рождения заявителя на кириллице и на латинице превышает 38 символов',
  ],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.birthPlaceLat', 'Место рождения заявителя содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeaturesV2.BIRTHPLACE_MISMATCH.applicant.birthPlaceLat',
    'Место рождения и/или Birthplace отсутствует в справочнике, либо не соответствует дате рождения',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.email', 'Укажите e-mail заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.email', 'Длина e-mail заявителя превышает 100 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.email', 'E-mail заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.WRONG_STRUCTURE.applicant.email', 'E-mail заявителя имеет неверную структуру'],
  [
    'VALIDATION.RequestFeaturesV2.LEADING_OR_TRAILING_DOT.applicant.email',
    'Имя пользователя в e-mail заявителя начинается или заканчивается символом точки',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.phone', 'Укажите телефон заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.phone', 'Длина телефона заявителя превышает 50 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.phone', 'Телефон заявителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.permAddress.address.country', 'Укажите страну в адресе заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.permAddress.address.country', 'Длина страны в адресе заявителя превышает 255 символов'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.permAddress.address.country',
    'Страна в адресе заявителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.permAddress.address.admDivision.value',
    'Укажите субъект федерации в адресе заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.permAddress.address.admDivision.value',
    'Длина субъекта федерации в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.permAddress.address.admDivision.value',
    'Субъект федерации в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.permAddress.address.region.value', 'Укажите район в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.permAddress.address.region.value',
    'Длина района в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.permAddress.address.region.value',
    'Район в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.permAddress.address.settlement', 'Укажите населённый пункт в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.permAddress.address.settlement',
    'Длина населённого пункта в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.permAddress.address.settlement',
    'Населённый пункт в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.permAddress.address.street.value', 'Укажите улицу в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.permAddress.address.street.value',
    'Длина улицы в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.permAddress.address.street.value',
    'Улица в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.permAddress.address.building.value', 'Укажите дом в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.permAddress.address.building.value',
    'Длина дома в адресе заявителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.permAddress.address.building.value',
    'Дом в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.permAddress.address.housing.value', 'Укажите корпус в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.permAddress.address.housing.value',
    'Длина корпуса в адресе заявителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.permAddress.address.housing.value',
    'Корпус в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.permAddress.address.structure.value', 'Укажите строение в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.permAddress.address.structure.value',
    'Длина строения в адресе заявителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.permAddress.address.structure.value',
    'Строение в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.permAddress.address.flat.value', 'Укажите квартиру в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.permAddress.address.flat.value',
    'Длина квартиры в адресе заявителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.permAddress.address.flat.value',
    'Квартира в адресе заявителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.applicant.permAddress.from.value',
    'Дата регистрации в адресе заявителя меньше даты рождения заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.permAddress.from.value', 'Недопустимая дата регистрации в адресе заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.tempAddress.address.country', 'Укажите страну в адресе заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.tempAddress.address.country', 'Длина страны в адресе заявителя превышает 255 символов'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.tempAddress.address.country',
    'Страна в адресе заявителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.tempAddress.address.admDivision.value',
    'Укажите субъект федерации в адресе заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.tempAddress.address.admDivision.value',
    'Длина субъекта федерации в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.tempAddress.address.admDivision.value',
    'Субъект федерации в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.tempAddress.address.region.value', 'Укажите район в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.tempAddress.address.region.value',
    'Длина района в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.tempAddress.address.region.value',
    'Район в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.tempAddress.address.settlement', 'Укажите населённый пункт в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.tempAddress.address.settlement',
    'Длина населённого пункта в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.tempAddress.address.settlement',
    'Населённый пункт в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.tempAddress.address.street.value', 'Укажите улицу в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.tempAddress.address.street.value',
    'Длина улицы в адресе заявителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.tempAddress.address.street.value',
    'Улица в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.tempAddress.address.building.value', 'Укажите дом в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.tempAddress.address.building.value',
    'Длина дома в адресе заявителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.tempAddress.address.building.value',
    'Дом в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.tempAddress.address.housing.value', 'Укажите корпус в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.tempAddress.address.housing.value',
    'Длина корпуса в адресе заявителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.tempAddress.address.housing.value',
    'Корпус в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.tempAddress.address.structure.value', 'Укажите строение в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.tempAddress.address.structure.value',
    'Длина строения в адресе заявителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.tempAddress.address.structure.value',
    'Строение в адресе заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.tempAddress.address.flat.value', 'Укажите квартиру в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.tempAddress.address.flat.value',
    'Длина квартиры в адресе заявителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.tempAddress.address.flat.value',
    'Квартира в адресе заявителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.applicant.tempAddress.from.value',
    'Дата регистрации в адресе заявителя меньше даты рождения заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.tempAddress.from.value', 'Недопустимая дата регистрации в адресе заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.applicant.tempAddress.to.value',
    'Дата окончания регистрации в адресе заявителя меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_FROM.applicant.tempAddress.to.value',
    'Дата окончания регистрации в адресе заявителя меньше даты регистрации в адресе заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.tempAddress.to.value',
    'Недопустимая дата окончания регистрации в адресе заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.activeFPassports.p1.series', 'Укажите серию действующего ОЗП'],
  ['VALIDATION.RequestFeaturesV2.TOO_SHORT.applicant.activeFPassports.p1.series', 'Длина серии действующего ОЗП менее 2 символов'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.activeFPassports.p1.series', 'Длина серии действующего ОЗП превышает 2 символа'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.activeFPassports.p1.series',
    'Серия действующего ОЗП содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.FOREIGN_PASSPORT_NOT_COMMON.applicant.activeFPassports.p1.series', 'Серия действующего ОЗП неверна'],
  [
    'VALIDATION.RequestFeaturesV2.FOREIGN_PASSPORT_UNKNOWN_SERIES.applicant.activeFPassports.p1.series',
    'Указанный паспорт имеет неизвестную серию',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.activeFPassports.p1.number', 'Укажите номер действующего ОЗП'],
  ['VALIDATION.RequestFeaturesV2.TOO_SHORT.applicant.activeFPassports.p1.number', 'Длина номера действующего ОЗП менее 7 символов'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.activeFPassports.p1.number', 'Длина номера действующего ОЗП превышает 7 символов'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.activeFPassports.p1.number',
    'Номер действующего ОЗП содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.activeFPassports.p1.issuer', 'Укажите наименование органа, выдавшего действующий ОЗП'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_SHORT.applicant.activeFPassports.p1.issuer',
    'Длина наименования органа, выдавшего действующий ОЗП, менее 2 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.activeFPassports.p1.issuer',
    'Длина наименования органа, выдавшего действующий ОЗП, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.activeFPassports.p1.issuer',
    'Наименование органа, выдавшего действующий ОЗП, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.activeFPassports.p1.issueDate.value', 'Укажите дату выдачи действующего ОЗП'],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.applicant.activeFPassports.p1.issueDate.value',
    'Дата выдачи действующего ОЗП меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.activeFPassports.p1.issueDate.value',
    'Недопустимая дата выдачи действующего ОЗП',
  ],
  [
    'VALIDATION.RequestFeaturesV2.FOREIGN_PASSPORT_EXPIRED.applicant.activeFPassports.p1.issueDate.value',
    'Срок действия ОЗП истёк (согласно его серии и дате выдачи)',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.activeFPassports.p2.series', 'Укажите серию действующего ОЗП'],
  ['VALIDATION.RequestFeaturesV2.TOO_SHORT.applicant.activeFPassports.p2.series', 'Длина серии действующего ОЗП менее 2 символов'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.activeFPassports.p2.series', 'Длина серии действующего ОЗП превышает 2 символа'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.activeFPassports.p2.series',
    'Серия действующего ОЗП содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.FOREIGN_PASSPORT_NOT_COMMON.applicant.activeFPassports.p2.series', 'Серия действующего ОЗП неверна'],
  [
    'VALIDATION.RequestFeaturesV2.FOREIGN_PASSPORT_UNKNOWN_SERIES.applicant.activeFPassports.p2.series',
    'Указанный паспорт имеет неизвестную серию',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.activeFPassports.p2.number', 'Укажите номер действующего ОЗП'],
  ['VALIDATION.RequestFeaturesV2.TOO_SHORT.applicant.activeFPassports.p2.number', 'Длина номера действующего ОЗП менее 7 символов'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.activeFPassports.p2.number', 'Длина номера действующего ОЗП превышает 7 символов'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.activeFPassports.p2.number',
    'Номер действующего ОЗП содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.activeFPassports.p2.issuer', 'Укажите наименование органа, выдавшего действующий ОЗП'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_SHORT.applicant.activeFPassports.p2.issuer',
    'Длина наименования органа, выдавшего действующий ОЗП, менее 2 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.activeFPassports.p2.issuer',
    'Длина наименования органа, выдавшего действующий ОЗП, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.activeFPassports.p2.issuer',
    'Наименование органа, выдавшего действующий ОЗП, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.activeFPassports.p2.issueDate.value', 'Укажите дату выдачи действующего ОЗП'],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.applicant.activeFPassports.p2.issueDate.value',
    'Дата выдачи действующего ОЗП меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.activeFPassports.p2.issueDate.value',
    'Недопустимая дата выдачи действующего ОЗП',
  ],
  [
    'VALIDATION.RequestFeaturesV2.FOREIGN_PASSPORT_EXPIRED.applicant.activeFPassports.p2.issueDate.value',
    'Срок действия ОЗП истёк (согласно его серии и дате выдачи)',
  ],
  [
    'VALIDATION.RequestFeaturesV2.FOREIGN_PASSPORT_NOT_CANCELED.applicant.activeFPassports',
    'Отметьте хотя бы один ОЗП как подлежащий к аннулированию',
  ],
  ['VALIDATION.RequestFeaturesV2.FOREIGN_PASSPORT_NOT_LOST.applicant.activeFPassports', 'Отметьте хотя бы один ОЗП как утраченный'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.jobRecords.position', 'Укажите должность в трудовой деятельности заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.jobRecords.position',
    'Длина должности в трудовой деятельности заявителя превышает 5530 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.jobRecords.position',
    'Должность в трудовой деятельности заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.jobRecords.address', 'Укажите адрес в трудовой деятельности заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.jobRecords.address',
    'Длина адреса в трудовой деятельности заявителя превышает 5530 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.jobRecords.address',
    'Адрес в трудовой деятельности заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.jobRecords.from.value', 'Укажите дату начала работы в трудовой деятельности заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.applicant.jobRecords.from.value',
    'Дата начала работы в трудовой деятельности заявителя меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.jobRecords.from.value',
    'Недопустимая дата начала работы в трудовой деятельности заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.jobRecords.to.value',
    'Укажите дату окончания работы в трудовой деятельности заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.applicant.jobRecords.to.value',
    'Дата окончания работы в трудовой деятельности заявителя меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_FROM.applicant.jobRecords.to.value',
    'Дата окончания работы в трудовой деятельности заявителя меньше соответствующей даты начала работы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.jobRecords.to.value',
    'Недопустимая дата окончания работы в трудовой деятельности заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.JOB_LIST_IS_EMPTY.applicant.jobRecords', 'Заполните трудовую деятельность заявителя'],
  ['VALIDATION.RequestFeaturesV2.WARN_FORMAT.applicant.jobRecords', 'Заполнен не весь период трудовой деятельности'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.jobManDate.value', 'Укажите дату заверения трудовой деятельности заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.DOCUMENT_AGE_GREATER_THAN_2.applicant.jobManDate.value',
    'Трудовая деятельность заявителя заверена более двух лет назад',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.jobManDate.value',
    'Недопустимая дата заверения трудовой деятельности заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.jobManName', 'Укажите лицо, заверившее трудовую деятельность заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.jobManName', 'Недопустимая длина лица, заверившего трудовую деятельность заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.jobManName',
    'Лицо, заверившее трудовую деятельность заявителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.hrManager.position',
    'Укажите должность лица, заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.hrManager.position',
    'Недопустимая длина должности заверившего трудовую деятельность заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.hrManager.position', 'Должность заверившего лица содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.hrManager.fullName.firstName',
    'Укажите имя лица, заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.hrManager.fullName.firstName',
    'Недопустимая длина имени заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.hrManager.fullName.firstName',
    'Имя заверившего лица содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.hrManager.fullName.lastName',
    'Укажите фамилию лица, заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.hrManager.fullName.lastName',
    'Недопустимая длина фамилии заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.hrManager.fullName.lastName',
    'Фамилия заверившего лица содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.hrManager.fullName.middleName.value',
    'Укажите отчество лица, заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.hrManager.fullName.middleName.value',
    'Недопустимая длина отчества заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.hrManager.fullName.middleName.value',
    'Отчество заверившего лица содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.hrManager.phone',
    'Укажите телефон лица, заверившего трудовую деятельность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.hrManager.phone',
    'Недопустимая длина телефона заверившего трудовую деятельность заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.hrManager.phone', 'Телефон заверившего лица содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.applicant.identityDocument.type.value',
    'Выберите тип документа, удостоверяющего личность заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.WARN.applicant.identityDocument.series', 'Укажите серию документа, удостоверяющего личность заявителя'],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.applicant.identityDocument.series',
    'Укажите серию документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_SHORT.applicant.identityDocument.series',
    'Недопустимая длина серии документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.identityDocument.series',
    'Недопустимая длина серии документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.identityDocument.series',
    'Серия документа, удостоверяющего личность заявителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.applicant.identityDocument.number',
    'Укажите номер документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_SHORT.applicant.identityDocument.number',
    'Недопустимая длина номера документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.identityDocument.number',
    'Недопустимая длина номера документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.identityDocument.number',
    'Номер документа, удостоверяющего личность заявителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.applicant.identityDocument.issuer',
    'Укажите наименование органа, выдавшего документ, удостоверяющий личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_SHORT.applicant.identityDocument.issuer',
    'Недопустимая длина наименования органа, выдавшего документ, удостоверяющий личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.identityDocument.issuer',
    'Недопустимая длина наименования органа, выдавшего документ, удостоверяющий личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.identityDocument.issuer',
    'Наименование органа, выдавшего документ, удостоверяющий личность заявителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.applicant.identityDocument.issueDate.value',
    'Укажите дату выдачи документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.applicant.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность заявителя, меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_YEAR_OF_1997.applicant.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность заявителя, меньше 1997 года',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_AGE_OF_14.applicant.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность заявителя, меньше даты наступления 14-летия заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.RUSSIAN_PASSPORT_EXPIRED_20.applicant.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность заявителя, недействителен в связи с наступлением 20-летия заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.RUSSIAN_PASSPORT_EXPIRED_45.applicant.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность заявителя, недействителен в связи с наступлением 45-летия заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.IDENTITY_DOCUMENT_MISMATCH.applicant.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность, недействителен. Истекло 90 дней со дня смены ФИО',
  ],
  [
    'VALIDATION.RequestFeaturesV2.BIRTHPLACE_CERT_WARN.applicant.identityDocument.issueDate.value',
    'Истекло 90 дней со дня смены ФИО, необходимо поменять свидетельство о рождении',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.identityDocument.issueDate.value',
    'Недопустимая дата выдачи документа, удостоверяющего личность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.APPLICANT_IDENITY_NOT_CONFIRMED.applicant.identityDocument',
    'Личность заявителя не удостоверена (паспортом РФ с 14 лет, свидетельством о рождении до 14 лет)',
  ],
  [
    'VALIDATION.RequestFeaturesV2.APPLICANT_IDENITY_NOT_CONFIRMED_RKZU_SITE.applicant.identityDocument',
    'Личность заявителя не удостоверена (паспортом РФ с 14 лет, свидетельством о рождении до 14 лет, действующим ОЗП)',
  ],
  [
    'VALIDATION.RequestFeaturesV2.APPLICANT_IDENITY_NOT_CONFIRMED_RKZU.applicant.identityDocument',
    'Личность заявителя не удостоверена (паспортом РФ с 14 лет, свидетельством о рождении до 14 лет, действующим ОЗП, подтверждением гражданства)',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.independentChildDocument.type.value',
    'Выберите тип документа, подтверждающего дееспособность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN.independentChildDocument.series',
    'Укажите серию документа, подтверждающего дееспособность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.independentChildDocument.series',
    'Длина серии документа, подтверждающего дееспособность заявителя, превышает 36 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.independentChildDocument.series',
    'Серия документа, подтверждающего дееспособность заявителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.independentChildDocument.number',
    'Укажите номер документа, подтверждающего дееспособность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.independentChildDocument.number',
    'Длина номера документа, подтверждающего дееспособность заявителя, превышает 36 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.independentChildDocument.number',
    'Номер документа, подтверждающего дееспособность заявителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.independentChildDocument.issuer',
    'Укажите наименование органа, выдавшего документ, подтверждающий дееспособность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.independentChildDocument.issuer',
    'Длина наименования органа, выдавшего документ, подтверждающий дееспособность заявителя, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.independentChildDocument.issuer',
    'Наименование органа, выдавшего документ, подтверждающий дееспособность заявителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.independentChildDocument.issueDate.value',
    'Укажите дату выдачи документа, подтверждающего дееспособность заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.independentChildDocument.issueDate.value',
    'Дата выдачи документа, подтверждающего дееспособность заявителя, меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_AGE_OF_14.independentChildDocument.issueDate.value',
    'Дата выдачи документа о дееспособности заявителя, меньше даты наступления 14-летия заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.independentChildDocument.issueDate.value',
    'Недопустимая дата выдачи документа, подтверждающего дееспособность заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.chipPhoto.scanned', 'Отсутствует цв. фотография заявителя'],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.printPhoto.scanned', 'Отсутствует ч/б фотография заявителя'],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.applicant.signature.scanned', 'Отсутствует подпись заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.fingerprints.hash', 'Отсутствуют отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.fingerprints.cert', 'Отсутствуют отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.fingerprints.ekey', 'Отсутствуют отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.fingerprints.digestURN', 'Отсутствуют отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.fingerprints.transportURN', 'Отсутствуют отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.representative.gender.value', 'Укажите пол законного представителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.representative.personIdentity.fullName.lastName', 'Укажите фамилию законного представителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.personIdentity.fullName.lastName',
    'Длина фамилии законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.personIdentity.fullName.lastName',
    'Фамилия законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN_FORMAT.representative.personIdentity.fullName.lastName',
    'Фамилия законного представителя содержит римские цифры',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.representative.personIdentity.fullName.firstName', 'Укажите имя законного представителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.personIdentity.fullName.firstName',
    'Длина имени законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.personIdentity.fullName.firstName',
    'Имя законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN_FORMAT.representative.personIdentity.fullName.firstName',
    'Имя законного представителя содержит римские цифры',
  ],
  [
    'VALIDATION.RequestFeaturesV2.GENDER_MISMATCH.representative.personIdentity.fullName.firstName',
    'Имя законного представителя не соответствует полу законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.personIdentity.fullName.middleName.value',
    'Укажите отчество законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.personIdentity.fullName.middleName.value',
    'Длина отчества законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.personIdentity.fullName.middleName.value',
    'Отчество законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN_FORMAT.representative.personIdentity.fullName.middleName.value',
    'Отчество законного представителя содержит римские цифры',
  ],
  [
    'VALIDATION.RequestFeaturesV2.GENDER_MISMATCH.representative.personIdentity.fullName.middleName.value',
    'Отчество законного представителя не соответствует полу законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.MIDDLE_NAME_STUBS.representative.personIdentity.fullName.middleName.value',
    `Отчество не может состоять только из символов "." или "-". Если у Вас отсутствует отчество, оставьте поле пустым и отметьте признак "Нет" для отчества.`,
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.representative.personIdentity.birthDate.value', 'Укажите дату рождения законного представителя'],
  [
    'VALIDATION.RequestFeaturesV2.PERSON_AGE_LESS_THAN_16.representative.personIdentity.birthDate.value',
    'Возраст законного представителя меньше 16 лет',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.representative.personIdentity.birthDate.value',
    'Недопустимая дата рождения законного представителя',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.representative.birthPlace', 'Укажите место рождения законного представителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.birthPlace',
    'Длина места рождения законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.birthPlace',
    'Место рождения законного представителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.representative.email', 'Укажите e-mail законного представителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.representative.email', 'Длина e-mail законного представителя превышает 100 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.email', 'E-mail законного представителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.WRONG_STRUCTURE.representative.email', 'E-mail законного представителя имеет неверную структуру'],
  [
    'VALIDATION.RequestFeaturesV2.LEADING_OR_TRAILING_DOT.representative.email',
    'Имя пользователя в e-mail законного представителя начинается или заканчивается символом точки',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.representative.phone', 'Укажите телефон законного представителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.representative.phone', 'Длина телефона законного представителя превышает 50 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.phone', 'Телефон законного представителя содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.representative.permAddress.address.country', 'Укажите страну в адресе законного представителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.permAddress.address.country',
    'Длина страны в адресе законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.permAddress.address.country',
    'Страна в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.permAddress.address.admDivision.value',
    'Укажите субъект федерации в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.permAddress.address.admDivision.value',
    'Длина субъекта федерации в адресе законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.permAddress.address.admDivision.value',
    'Субъект федерации в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.permAddress.address.region.value',
    'Укажите район в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.permAddress.address.region.value',
    'Длина района в адресе законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.permAddress.address.region.value',
    'Район в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.permAddress.address.settlement',
    'Укажите населённый пункт в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.permAddress.address.settlement',
    'Длина населённого пункта в адресе законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.permAddress.address.settlement',
    'Населённый пункт в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.permAddress.address.street.value',
    'Укажите улицу в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.permAddress.address.street.value',
    'Длина улицы в адресе законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.permAddress.address.street.value',
    'Удица в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.permAddress.address.building.value',
    'Укажите дом в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.permAddress.address.building.value',
    'Длина дома в адресе законного представителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.permAddress.address.building.value',
    'Дом в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.permAddress.address.housing.value',
    'Укажите корпус в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.permAddress.address.housing.value',
    'Длина корпуса в адресе законного представителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.permAddress.address.housing.value',
    'Корпус в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.permAddress.address.structure.value',
    'Укажите строение в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.permAddress.address.structure.value',
    'Длина строения в адресе законного представителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.permAddress.address.structure.value',
    'Строение в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.permAddress.address.flat.value',
    'Укажите квартиру в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.permAddress.address.flat.value',
    'Длина квартиры в адресе законного представителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.permAddress.address.flat.value',
    'Квартира в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.representative.permAddress.from.value',
    'Дата регистрации в адресе законного представителя меньше даты рождения законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.representative.permAddress.from.value',
    'Недопустимая дата регистрации в адресе законного представителя',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.representative.tempAddress.address.country', 'Укажите страну в адресе законного представителя'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.tempAddress.address.country',
    'Длина страны в адресе законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.tempAddress.address.country',
    'Страна в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.INCORRECT_COUNTRY_NAME.applicant.permAddress.address.country',
    'Некорректное значение в поле "Страна". Если ваше место жительства на территории РФ, то укажите РОССИЙСКАЯ ФЕДЕРАЦИЯ.',
  ],
  [
    'VALIDATION.RequestFeaturesV2.INCORRECT_COUNTRY_NAME.applicant.tempAddress.address.country',
    'Некорректное значение в поле "Страна". Если вы проживаете на территории РФ, то укажите РОССИЙСКАЯ ФЕДЕРАЦИЯ.',
  ],
  [
    'VALIDATION.RequestFeaturesV2.INCORRECT_COUNTRY_NAME.representative.permAddress.address.country',
    'Некорректное значение в поле "Страна". Если ваше место жительства на территории РФ, то укажите РОССИЙСКАЯ ФЕДЕРАЦИЯ.',
  ],
  [
    'VALIDATION.RequestFeaturesV2.INCORRECT_COUNTRY_NAME.representative.tempAddress.address.country',
    'Некорректное значение в поле "Страна". Если вы проживаете на территории РФ, то укажите РОССИЙСКАЯ ФЕДЕРАЦИЯ.',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.tempAddress.address.admDivision.value',
    'Укажите субъект федерации в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.tempAddress.address.admDivision.value',
    'Длина субъекта федерации в адресе законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.tempAddress.address.admDivision.value',
    'Субъект федерации в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.tempAddress.address.region.value',
    'Укажите район в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.tempAddress.address.region.value',
    'Длина района в адресе законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.tempAddress.address.region.value',
    'Район в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.tempAddress.address.settlement',
    'Укажите населённый пункт в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.tempAddress.address.settlement',
    'Длина населённого пункта в адресе законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.tempAddress.address.settlement',
    'Населённый пункт в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.tempAddress.address.street.value',
    'Укажите улицу в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.tempAddress.address.street.value',
    'Длина улицы в адресе законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.tempAddress.address.street.value',
    'Улица в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.tempAddress.address.building.value',
    'Укажите дом в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.tempAddress.address.building.value',
    'Длина дома в адресе законного представителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.tempAddress.address.building.value',
    'Дом в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.tempAddress.address.housing.value',
    'Укажите корпус в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.tempAddress.address.housing.value',
    'Длина корпуса в адресе законного представителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.tempAddress.address.housing.value',
    'Корпус в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.tempAddress.address.structure.value',
    'Укажите строение в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.tempAddress.address.structure.value',
    'Длина строения в адресе законного представителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.tempAddress.address.structure.value',
    'Строение в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.tempAddress.address.flat.value',
    'Укажите квартиру в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.tempAddress.address.flat.value',
    'Длина квартиры в адресе законного представителя превышает 20 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.tempAddress.address.flat.value',
    'Квартира в адресе законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.representative.tempAddress.from.value',
    'Дата регистрации в адресе законного представителя меньше даты рождения законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.representative.tempAddress.from.value',
    'Недопустимая дата регистрации в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.representative.tempAddress.to.value',
    'Дата окончания регистрации в адресе законного представителя меньше даты рождения законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_FROM.representative.tempAddress.to.value',
    'Дата окончания регистрации в адресе законного представителя меньше даты регистрации в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.representative.tempAddress.to.value',
    'Недопустимая дата окончания регистрации в адресе законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.identityDocument.type.value',
    'Выберите тип документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.identityDocument.series',
    'Укажите серию документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_SHORT.representative.identityDocument.series',
    'Недопустимая длина серии документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.identityDocument.series',
    'Недопустимая длина серии документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.identityDocument.series',
    'Серия документа, удостоверяющего личность законного представителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.identityDocument.number',
    'Укажите номер документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_SHORT.representative.identityDocument.number',
    'Недопустимая длина номера документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.identityDocument.number',
    'Недопустимая длина номера документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.identityDocument.number',
    'Номер документа, удостоверяющего личность законного представителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.identityDocument.issuer',
    'Укажите наименование органа, выдавшего документ, удостоверяющий личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_SHORT.representative.identityDocument.issuer',
    'Недопустимая длина наименования органа, выдавшего документ, удостоверяющий личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.identityDocument.issuer',
    'Недопустимая длина наименования органа, выдавшего документ, удостоверяющий личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.identityDocument.issuer',
    'Наименование органа, выдавшего документ, удостоверяющий личность законного представителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.identityDocument.issueDate.value',
    'Укажите дату выдачи документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.representative.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность законного представителя, меньше даты рождения законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_YEAR_OF_1997.representative.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность законного представителя, меньше 1997 года',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_AGE_OF_14.representative.identityDocument.issueDate.value',
    'Дата выдачи документа, удостоверяющего личность законного представителя, меньше даты наступления 14-летия законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.RUSSIAN_PASSPORT_EXPIRED_20.representative.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность законного представителя, недействителен в связи с наступлением 20-летия законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.RUSSIAN_PASSPORT_EXPIRED_45.representative.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность законного представителя, недействителен в связи с наступлением 45-летия законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.IDENTITY_DOCUMENT_MISMATCH.representative.identityDocument.issueDate.value',
    'Документ, удостоверяющий личность законного представителя, недействителен в связи со сменой ФИО законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.FOREIGN_PASSPORT_EXPIRED.representative.identityDocument.issueDate.value',
    'Срок действия документа, удостоверяющего личность законного представителя, истёк (согласно его серии и дате выдачи)',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.representative.identityDocument.issueDate.value',
    'Недопустимая дата выдачи документа, удостоверяющего личность законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.representativeProof.type.value',
    'Выберите тип документа, подтверждающего права законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN.representative.representativeProof.series',
    'Укажите серию документа, подтверждающего права законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.representativeProof.series',
    'Длина серии документа, подтверждающего права законного представителя, превышает 36 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.representativeProof.series',
    'Серия документа, подтверждающего права законного представителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.representativeProof.number',
    'Укажите номер документа, подтверждающего права законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.representativeProof.number',
    'Длина номера документа, подтверждающего права законного представителя, превышает 36 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.representativeProof.number',
    'Номер документа, подтверждающего права законного представителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.representativeProof.issuer',
    'Укажите наименование органа, выдавшего документ, подтверждающий права законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_SHORT.representative.representativeProof.issuer',
    'Недопустимая длина наименования органа, выдавшего документ, подтверждающий права законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.representativeProof.issuer',
    'Недопустимая длина наименования органа, выдавшего документ, подтверждающий права законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.representativeProof.issuer',
    'Наименование органа, выдавшего документ, подтверждающий права законного представителя, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.representativeProof.issueDate.value',
    'Укажите дату выдачи документа, подтверждающего права законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_APP_BIRTHDATE.representative.representativeProof.issueDate.value',
    'Дата выдачи документа, подтверждающего права законного представителя, меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_REP_BIRTHDATE.representative.representativeProof.issueDate.value',
    'Дата выдачи документа, подтверждающего права законного представителя, меньше даты рождения законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.IDENTITY_DOCUMENT_MISMATCH.representative.representativeProof.issueDate.value',
    'Документ, подтверждающий права законного представителя, недействителен в связи со сменой ФИО заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.BIRTHPLACE_CERT_WARN.representative.representativeProof.issueDate.value',
    'Истекло 90 дней со дня смены ФИО заявителя, необходимо поменять свидетельство о рождении несовершннолетнего',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.representative.representativeProof.issueDate.value',
    'Недопустимая дата выдачи документа, подтверждающего права законного представителя',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.representative.trustRecipient.gender.value', 'Укажите пол второго законного представителя'],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.trustRecipient.personIdentity.fullName.lastName',
    'Укажите фамилию второго законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.trustRecipient.personIdentity.fullName.lastName',
    'Длина фамилии второго законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.trustRecipient.personIdentity.fullName.lastName',
    'Фамилия второго законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN_FORMAT.representative.trustRecipient.personIdentity.fullName.lastName',
    'Фамилия второго законного представителя содержит римские цифры',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.trustRecipient.personIdentity.fullName.firstName',
    'Укажите имя второго законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.trustRecipient.personIdentity.fullName.firstName',
    'Длина имени второго законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.trustRecipient.personIdentity.fullName.firstName',
    'Имя второго законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN_FORMAT.representative.trustRecipient.personIdentity.fullName.firstName',
    'Имя второго законного представителя содержит римские цифры',
  ],
  [
    'VALIDATION.RequestFeaturesV2.GENDER_MISMATCH.representative.trustRecipient.personIdentity.fullName.firstName',
    'Имя второго законного представителя не соответствует полу законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.trustRecipient.personIdentity.fullName.middleName.value',
    'Укажите отчество второго законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.trustRecipient.personIdentity.fullName.middleName.value',
    'Длина отчества второго законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.trustRecipient.personIdentity.fullName.middleName.value',
    'Отчество второго законного представителя содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WARN_FORMAT.representative.trustRecipient.personIdentity.fullName.middleName.value',
    'Отчество второго законного представителя содержит римские цифры',
  ],
  [
    'VALIDATION.RequestFeaturesV2.GENDER_MISMATCH.representative.trustRecipient.personIdentity.fullName.middleName.value',
    'Отчество второго законного представителя не соответствует полу законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.MIDDLE_NAME_STUBS.representative.trustRecipient.personIdentity.fullName.middleName.value',
    `Отчество не может состоять только из символов "." или "-". Если у Вас отсутствует отчество, оставьте поле пустым и отметьте признак "Нет" для отчества.`,
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.representative.trustRecipient.personIdentity.birthDate.value',
    'Укажите дату рождения второго законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.PERSON_AGE_LESS_THAN_16.representative.trustRecipient.personIdentity.birthDate.value',
    'Возраст второго законного представителя меньше 16 лет',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.representative.trustRecipient.personIdentity.birthDate.value',
    'Недопустимая дата рождения второго законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.representative.trustRecipient.birthPlace',
    'Укажите место рождения второго законного представителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.representative.trustRecipient.birthPlace',
    'Длина места рождения второго законного представителя превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.representative.trustRecipient.birthPlace',
    'Место рождения второго законного представителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.cause.value', 'Укажите тип получения паспорта'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.secretAccess.value.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.secretAccess.organization', 'Укажите наименование организации'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.secretAccess.organization', 'Длина наименования организации превышает 4096 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.secretAccess.organization', 'Наименование организации содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.secretAccess.year.value', 'Укажите год работы в организации'],
  ['VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.secretAccess.year.value', 'Год работы в организации меньше даты рождения заявителя'],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.secretAccess.year.value', 'Недопустимое значение года работы в организации'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.contractObligations.value.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.contractObligations.organization', 'Укажите наименование организации'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.contractObligations.organization', 'Длина наименования организации превышает 4096 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.contractObligations.organization', 'Наименование организации содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.contractObligations.year.value', 'Укажите год работы в организации'],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.contractObligations.year.value',
    'Год работы в организации меньше даты рождения заявителя',
  ],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.contractObligations.year.value', 'Недопустимое значение года работы в организации'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.militaryService.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.convicted.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.accused.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.legalObligations.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.dipServiceControlData.dutyOrganization', 'Укажите наименование организации'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.dipServiceControlData.dutyOrganization', 'Укажите наименование организации'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.dipServiceControlData.dutyOrganization', 'Длина наименования организации превышает 255 символов'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.dipServiceControlData.dutyOrganization',
    'Наименование организации содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.dipServiceControlData.dutyPosition', 'Укажите должность и место работы'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.dipServiceControlData.dutyPosition', 'Укажите должность и место работы'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.dipServiceControlData.dutyPosition', 'Длина должности и места работы превышает 255 символов'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.dipServiceControlData.dutyPosition',
    'Поле должности и места работы содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.dipServiceControlData.dutyDuration', 'Укажите срок командировки'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.dipServiceControlData.dutyDuration', 'Укажите срок командировки'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.dipServiceControlData.dutyDuration', 'Длина срока командировки превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.dipServiceControlData.dutyDuration', 'Поле срока командировки содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.dipServiceControlData.dutyCountry', 'Укажите страну командировки'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.dipServiceControlData.dutyCountry', 'Укажите страну командировки'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.dipServiceControlData.dutyCountry', 'Длина страны командировки превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.dipServiceControlData.dutyCountry', 'Страна командировки содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.dipServiceControlData.secretAware.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.dipServiceControlData.secretAware.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.dipServiceControlData.secretAware.value', 'Длина поля превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.dipServiceControlData.secretAware.value', 'Поле содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.dipServiceControlData.secretAdmitted.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.dipServiceControlData.secretAdmitted.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.dipServiceControlData.secretAdmitted.value', 'Длина поля превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.dipServiceControlData.secretAdmitted.value', 'Поле содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.dipServiceControlData.contracts.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.dipServiceControlData.contracts.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.dipServiceControlData.contracts.value', 'Длина поля превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.dipServiceControlData.contracts.value', 'Поле содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.dipServiceControlData.trips.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.dipServiceControlData.trips.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.dipServiceControlData.trips.value', 'Длина поля превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.dipServiceControlData.trips.value', 'Поле содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.bankrupt.value', 'Укажите ограничение выезда'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.mailing.addressRus', 'Укажите адрес почтового отправления'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.mailing.addressRus', 'Длина адреса почтового отправления превышает 1024 символа'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.mailing.addressRus', 'Адрес почтового отправления содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.mailing.addressLat', 'Укажите адрес почтового отправления'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.mailing.addressLat', 'Длина адреса почтового отправления превышает 1024 символа'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.mailing.addressLat', 'Адрес почтового отправления содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.citizenshipCertificate.number', 'Укажите номер заключения о наличии гражданства'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.citizenshipCertificate.number',
    'Длина номера заключения о наличии гражданства превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.citizenshipCertificate.number',
    'Номер заключения о наличии гражданства содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.citizenshipCertificate.date.value', 'Укажите дату заключения о наличии гражданства'],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.citizenshipCertificate.date.value',
    'Дата заключения о наличии гражданства меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.DOCUMENT_AGE_GREATER_THAN_1.citizenshipCertificate.date.value',
    'Заключение о наличии гражданства оформлено более года назад',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.citizenshipCertificate.date.value',
    'Недопустимое значение даты заключения о наличии гражданства',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.citizenshipCertificate.officerPost',
    'Укажите должность заверителя заключения о наличии гражданства',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.citizenshipCertificate.officerPost',
    'Длина должности заверителя заключения о наличии гражданства превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.citizenshipCertificate.officerPost',
    'Должность заверителя заключения о наличии гражданства содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.citizenshipCertificate.officerName',
    'Укажите ФИО заверителя заключения о наличии гражданства',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.citizenshipCertificate.officerName',
    'Длина ФИО заверителя заключения о наличии гражданства превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.citizenshipCertificate.officerName',
    'ФИО заверителя заключения о наличии гражданства содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.citizenshipCertificate.testimony', 'Укажите текст заключения о наличии гражданства'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.citizenshipCertificate.testimony',
    'Длина текста заключения о наличии гражданства превышает 4096 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.citizenshipCertificate.testimony',
    'Текст заключения о наличии гражданства содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.presidentEdict.number', 'Укажите номер указа о приёме в гражданство'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.presidentEdict.number', 'Длина номера указа о приёме в гражданство превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.presidentEdict.number', 'Номер указа о приёме в гражданство содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.presidentEdict.date.value', 'Укажите дату указа о приёме в гражданство'],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.presidentEdict.date.value', 'Недопустимое значение даты указа о приёме в гражданство'],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.presidentEdict.date.value',
    'Дата указа о приёме в гражданство меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.DOCUMENT_AGE_GREATER_THAN_3.presidentEdict.date.value',
    'Указ о приёме в гражданство оформлен более 3-х месяцев назад',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.citizenshipDecision.number', 'Укажите номер заявления о вступлении в гражданство'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.citizenshipDecision.number',
    'Длина номера заявления о вступлении в гражданство превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.citizenshipDecision.number',
    'Номер заявления о вступлении в гражданство содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.citizenshipDecision.date.value', 'Укажите дату решения о вступлении в гражданство'],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.citizenshipDecision.date.value',
    'Недопустимое значение даты решения о вступлении в гражданство',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.citizenshipDecision.date.value',
    'Дата решения о вступлении в гражданство меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.DOCUMENT_AGE_GREATER_THAN_3.citizenshipDecision.date.value',
    'Решение о вступлении в гражданство оформлено более 3-х месяцев назад',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.citizenshipDecision.officerPost',
    'Укажите должность руководителя, принявшего решение о вступлении в гражданство',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.citizenshipDecision.officerPost',
    'Длина должности руководителя, принявшего решение о вступлении в гражданство, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.citizenshipDecision.officerPost',
    'Должность руководителя, принявшего решение о вступлении в гражданство, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.citizenshipDecision.officerName',
    'Укажите ФИО руководителя, принявшего решение о вступлении в гражданство',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.citizenshipDecision.officerName',
    'Длина ФИО руководителя, принявшего решение о вступлении в гражданство, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.citizenshipDecision.officerName',
    'ФИО руководителя, принявшего решение о вступлении в гражданство, содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.citizenshipDecision.article',
    'Укажите статью, на основании которой было принято решение о вступлении в гражданство',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.citizenshipDecision.article',
    'Длина статьи, на основании которой было принято решение о вступлении в гражданство, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.citizenshipDecision.article',
    'Статья, на основании которой было принято решение о вступлении в гражданство, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.soldierPermission.number', 'Укажите номер справки военнослужащего'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.soldierPermission.number', 'Длина номера справки военнослужащего превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.soldierPermission.number', 'Номер справки военнослужащего содержит недопустимые символы'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.soldierPermission.date.value', 'Укажите дату справки военнослужащего'],
  ['VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.soldierPermission.date.value', 'Недопустимое значение даты справки военнослужащего'],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.soldierPermission.date.value',
    'Дата справки военнослужащего меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.soldierPermission.signerPost',
    'Укажите должность сотрудника, подписавшего справку военнослужащего',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.soldierPermission.signerPost',
    'Длина должности сотрудника, подписавшего справку военнослужащего, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.soldierPermission.signerPost',
    'Должность сотрудника, подписавшего справку военнослужащего, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.soldierPermission.signerName', 'Укажите ФИО сотрудника, подписавшего справку военнослужащего'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.soldierPermission.signerName',
    'Длина ФИО сотрудника, подписавшего справку военнослужащего, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.soldierPermission.signerName',
    'ФИО сотрудника, подписавшего справку военнослужащего, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.soldierPermission.agreementNumber', 'Укажите номер согласования справки военнослужащего в ФСБ'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.soldierPermission.agreementNumber',
    'Длина номера согласования справки военнослужащего в ФСБ превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.soldierPermission.agreementNumber',
    'Номер согласования справки военнослужащего в ФСБ содержит недопустимые символы',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.soldierPermission.agreementDate.value',
    'Укажите дату согласования справки военнослужащего в ФСБ',
  ],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_BIRTHDATE.soldierPermission.agreementDate.value',
    'Дата согласования справки военнослужащего в ФСБ меньше даты рождения заявителя',
  ],
  [
    'VALIDATION.RequestFeaturesV2.NOT_ALLOWED_VALUE.soldierPermission.agreementDate.value',
    'Недопустимое значение даты согласования справки военнослужащего в ФСБ',
  ],
  [
    'VALIDATION.RequestFeaturesV2.REQUIRED.soldierPermission.deciderName',
    'Укажите ФИО сотрудника, принявшего решение о выдаче паспорта военнослужащему',
  ],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.soldierPermission.deciderName',
    'Длина ФИО сотрудника, принявшего решение о выдаче паспорта военнослужащему, превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.soldierPermission.deciderName',
    'ФИО сотрудника, принявшего решение о выдаче паспорта военнослужащему, содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.soldierPermission.militaryUnit', 'Укажите номер военной части военнослужащего'],
  [
    'VALIDATION.RequestFeaturesV2.TOO_LONG.soldierPermission.militaryUnit',
    'Длина номера военной части военнослужащего превышает 255 символов',
  ],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.soldierPermission.militaryUnit',
    'Номер военной части военнослужащего содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.fingerprintsRequired.value', 'Укажите, требуются ли отпечатки пальцев заявителя'],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.receptionUser', 'Укажите ФИО сотрудника, принявшего заявление'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.receptionUser', 'Укажите ФИО сотрудника, принявшего заявление'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.receptionUser', 'Длина ФИО сотрудника, принявшего заявление, превышает 255 символов'],
  ['VALIDATION.RequestFeaturesV2.WRONG_FORMAT.receptionUser', 'ФИО сотрудника, принявшего заявление, содержит недопустимые символы'],
  [
    'VALIDATION.RequestFeaturesV2.LESS_THAN_ISSUE_DATE.personalizedForeignPassport.expireDate',
    'Дата окончания действия меньше даты выдачи',
  ],
  ['VALIDATION.RequestFeaturesV2.CANNOT_BE_EMPTY.applicant.secondNationality.value', 'Укажите второе гражданство заявителя'],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.applicant.secondNationality.value', 'Укажите второе гражданство заявителя'],
  ['VALIDATION.RequestFeaturesV2.TOO_LONG.applicant.secondNationality.value', 'Длина второго гражданства заявителя превышает 255 символов'],
  [
    'VALIDATION.RequestFeaturesV2.WRONG_FORMAT.applicant.secondNationality.value',
    'Второе гражданство заявителя содержит недопустимые символы',
  ],
  ['VALIDATION.RequestFeaturesV2.REQUIRED.goal.value', 'Укажите цель получения паспорта'],

  ['VALIDATION.FeedbackDialogModel.REQUIRED.name', 'Введите имя'],
  ['VALIDATION.FeedbackDialogModel.REQUIRED.email', 'Введите e-mail'],
  ['VALIDATION.FeedbackDialogModel.TOO_LONG.email', 'Длина e-mail превышает 100 символов'],
  ['VALIDATION.FeedbackDialogModel.WRONG_FORMAT.email', 'Неправильный формат e-mail'],
  ['VALIDATION.FeedbackDialogModel.REQUIRED.department', 'Укажите подразделение'],
  ['VALIDATION.FeedbackDialogModel.REQUIRED.text', 'Введите текст'],

  ['STATUS.RequestFeatures.DATA_ENTERED', 'Черновик'],
  ['STATUS.RequestFeaturesV2.DATA_ENTERED', 'Черновик'],

  ['request.tab.department', 'Консульское учреждение'],
  ['request.tab.person', 'Общие сведения'],
  ['request.tab.documents', 'Документы'],
  ['request.tab.address', 'Адрес'],
  ['request.tab.jobs', 'Трудовая деятельность'],
  ['request.tab.representative', 'Законный представитель'],
  ['request.tab.restrictions', 'Ограничения'],
  ['request.tab.misc', 'Прочее'],
  ['request.tab.photo', 'Фотография'],
  ['request.tab.signature', 'Подпись'],
  ['request.tab.fingerprints', 'Отпечатки'],
  ['request.tab.wacom', 'Подпись'],

  ['photoWizard.label.cameraInitializationInProgress', 'Инициализация камеры'],
  ['photoWizard.label.cropInProgress', 'Обрезка фотографии'],
  ['photoWizard.label.inProсess', 'Обработка фотографии'],
  ['photoWizard.label.rotate', 'Переключение камер'],
  ['photoWizard.label.cameraInitializationError', 'Ошибка при инициализации камеры'],
  ['photoWizard.label.qrDecodeError', 'Ошибка декодирования QR кода'],
  ['photoWizard.label.printPhoto', 'Фото на печать'],
  ['photoWizard.label.chipPhoto', 'Фото в микросхеме'],
  ['photoWizard.command.enroll', 'Сделать фото'],
  ['photoWizard.label.variant', 'Вариант '],
  ['photoWizard.command.process', 'Обработать'],
  ['photoWizard.command.apply', 'Принять'],
  ['photoWizard.command.restart', 'Новое фото'],
  ['photoWizard.command.cancel', 'Закрыть'],
  ['photoWizard.label.stationary', 'Приложите паспорт к считывателю'],

  ['fingerprints.error.connection', 'Ошибка сканера отпечатков пальцев'],
  ['fingerprints.error.badquality', 'Отпечатки пальцев отсканировались в плохом качестве. Повторите сканирование!'],
  ['fingerprints.success.goodquality', 'Отпечатки пальцев отсканировались успешно.'],
  ['fingerprints.error.encrypt', 'Ошибка шифрования'],
  ['fingerprints.success.encrypt', 'Шифрование завершено'],
  ['fingerprints.error.scaning', 'Ошибка сканера'],
  ['fingerprints.process.encrypt', 'Идёт процесс шифрования'],

  ['signature.clear', 'Очистить'],
  ['signature.dash', 'Прочерк'],
  ['signature.photo', 'Фото'],
  ['signature.edit', 'Редактировать'],
  ['signature.done', 'Готово'],

  ['scanMRZ.command.continue', 'Продолжить'],
  ['scanMRZ.command.continue-text', 'MRZ считана успешно, приложите паспорт к считывателю NFC и нажмите ПРОДОЛЖИТЬ'],

  ['VERIFICATION.title', 'Верификация'],
  ['VERIFICATION.data', 'Данные'],
  ['VERIFICATION.applicant', 'Заявителя'],
  ['VERIFICATION.print', 'Печатные'],
  ['VERIFICATION.chip', 'Микросхема'],
  ['VERIFICATION.nophoto', 'Нет фото'],
  ['VERIFICATION.final.signature', 'ЭП:'],
  ['VERIFICATION.final.signature.valid', 'верна'],
  ['VERIFICATION.final.signature.invalid', 'неверна'],
  ['VERIFICATION.final.fingerprints', 'Отпечатки пальцев:'],
  ['VERIFICATION.final.fingerprints.valid', 'подпись верна'],
  ['VERIFICATION.final.fingerprints.invalid', 'подпись неверна'],
  ['VERIFICATION.final.fingerprints.missing', 'отсутствуют'],
  ['VERIFICATION.final.fingerprints.disabled', 'верификация отключена'],
  ['VERIFICATION.final.fingerprints.skipped', 'процесс пропущен'],

  ['PASSPORT.VERIFICATION.photo', 'Фотография'],
  ['PASSPORT.VERIFICATION.typeD', 'Тип документа'],
  ['PASSPORT.VERIFICATION.typeP', 'Тип паспорта'],
  ['PASSPORT.VERIFICATION.country', 'Страна'],
  ['PASSPORT.VERIFICATION.lastName', 'Фамилия'],
  ['PASSPORT.VERIFICATION.lastNameLat', 'Фамилия Латиницей'],
  ['PASSPORT.VERIFICATION.firstName', 'Имя'],
  ['PASSPORT.VERIFICATION.firstNameLat', 'Имя Латиницей'],
  ['PASSPORT.VERIFICATION.middleName', 'Отчество'],
  ['PASSPORT.VERIFICATION.serial', 'Серия/Номер'],
  ['PASSPORT.VERIFICATION.nationality', 'Национальность'],
  ['PASSPORT.VERIFICATION.birthDate', 'Дата рождения'],
  ['PASSPORT.VERIFICATION.gender', 'Пол'],
  ['PASSPORT.VERIFICATION.validdate', 'Действителен до'],

  ['PASSPORT.VERIFICATION.COMPLETED', 'Чтение паспорта завершено'],
  ['PASSPORT.VERIFICATION.ERROR.CONNECT', 'Ошибка подключения к считывателю паспортов'],
  ['PASSPORT.VERIFICATION.ERROR.ACTIVATION', 'Ошибка активации паспорта'],
  ['PASSPORT.VERIFICATION.ERROR.AC', 'Ошибка проверки безопасности'],
  ['PASSPORT.VERIFICATION.ERROR.FINGERPRINTS', 'Не верны отпечатки'],
  ['PASSPORT.VERIFICATION.ERROR.READ', 'Ошибка чтения данных'],
  ['PASSPORT.VERIFICATION.ERROR.SOD.ICAO', 'Ошибка чтения электронной подписи ICAO'],
  ['PASSPORT.VERIFICATION.ERROR.SOD.GOST', 'Ошибка чтения электронной подписи GOST'],
  ['PASSPORT.VERIFICATION.ERROR.CONVERT', 'Ошибка конвертирования фотографии'],
  ['PASSPORT.VERIFICATION.ERROR.VERIFY', 'Ошибка проверки электронных подписей'],
  ['PASSPORT.VERIFICATION.ERROR.UPLOAD.CVCA.LINKS', 'Ошибка загрузки link-сертификатов'],

  ['PASSPORT.SERVICE.METHOD.readDG', 'считывание группы данных'],
  ['PASSPORT.SERVICE.METHOD.initEAC', 'инициализация EAC'],
  ['PASSPORT.SERVICE.METHOD.initBAC', 'инициализация BAC'],
  ['PASSPORT.SERVICE.METHOD.uploadCVCALinks', 'загрузка link-сертификатов'],
  ['PASSPORT.SERVICE.ERROR.CODE.6', 'паспорт не активирован'],
  ['PASSPORT.SERVICE.ERROR.CODE.9', 'файл отутствует'],
  ['PASSPORT.SERVICE.ERROR.CODE.16', 'ошибка криптографии'],
  ['PASSPORT.SERVICE.ERROR.CODE.21', 'не загружены link-сертификаты'],
  ['PASSPORT.SERVICE.ERROR.CODE.36', 'ошибка считывателя: не прошла команда микросхеме паспорта'],

  ['confirmation.import.duplicate.request', 'Заявление с данными Ф.И.О. и датой рождения уже имеется в списке заявлений. Продолжить?'],
  ['confirmation.restore.draft', 'Восстановить несохранённые данные?'],
  ['confirmation.mobile.delete.requests', 'Восстановить удалённые заявления будет невозможно. Хотите продолжить?'],
  ['confirmation.delete.requests', 'Удалить заявления?'],
  ['confirmation.delete.fingerprints', 'Отпечатки пальцев будут удалены, поскольку заявитель младше 12 лет. Продолжить?'],
  ['confirmation.delete.photo', 'Вы действительно хотите удалить данную фотографию из заявления?'],
  ['confirmation.reset.passphrase', 'После смены кодового слова все заявления будут удалены из хранилища. Продолжить?'],
  ['confirmation.save', 'Сохранить измененные данные?'],

  ['setting.sync.server.addr', 'Адрес сервера ПВДНП для синхронизации выездного обслуживания'],
  ['setting.dept.name', 'Наименование подразделения'],
  ['setting.load.error', 'Ошибка загрузки настроек'],
  ['setting.save.error', 'Ошибка сохранения настроек'],
  ['setting.save.success', 'Настройки сохранены'],
  ['settings.submit', 'Сохранить'],
  ['setting.print.mode', 'Режим печати'],
  ['print.mode.ThermalPrinter', 'Термопринтер'],
  ['print.mode.AutomaticDoublesided', 'Автоматическая двусторонняя печать'],
  ['print.mode.ManualDoublesided', 'Ручная двусторонняя печать'],

  ['date.setting.search.input.label', 'Выберите дату и время'],
  ['enter', 'Войти'],
  ['login', 'Имя пользователя:'],
  ['password', 'Пароль:'],
  ['login.fail', 'Неверное имя пользователя или пароль'],
  ['login.success', 'Добро пожаловать, {0}!'],
  ['quit', 'Выйти'],
  ['quit.message', 'Сеанс завершен'],
  ['admin.password', 'Пароль администратора'],
  ['new.user', 'Новый пользователь'],
  ['new.user.login', 'Логин:'],
  ['new.user.password', 'Пароль:'],
  ['new.user.add', '+'],
  ['users.delete', 'X'],
  ['users.delete.error', 'Ошибка удаления пользователя'],
  ['users.add.error', 'Ошибка добавления пользователя'],
  ['all.users', 'Пользователи'],
  ['user.old.passsword', 'Старый пароль'],
  ['user.new.password', 'Новый пароль'],
  ['user.confirm.new.password', 'Подтверждение нового пароля'],
  ['user.submit.change.password', 'Сохранить'],
  ['user.fail.password.confirmation', 'Введенные пароли не совпадают'],
  ['user.fail.password', 'Неправильный старый пароль'],
  ['users.password.change.success', 'Пароль успешно изменен'],
  ['users.delete.confirmation', 'Удалить данного пользователя?'],
  ['user.password.change.fail', 'Произошла ошибка. Пароль не был изменен.'],
  ['auth.header', 'АРМ Выездного обслуживания'],
  ['auth.title', 'Авторизация'],
  ['user.profile.lastName', 'Фамилия'],
  ['user.profile.name', 'Имя'],
  ['user.profile.middleName', 'Отчество'],
  ['user.profile', 'Профиль пользователя'],
  ['user.profile.email', 'Email'],
  ['user.profile.job.position', 'Должность'],
  ['user.profile.is.rcod', 'РЦОД'],
  ['user.profile.department.code', 'Код подразделения'],
  ['user.save.profile.success', 'Профиль успешно изменен'],
  ['user.save.profile.error', 'Ошибка изменения профиля'],
  ['users.table.user', 'Пользователь'],
  ['users.table.login', 'Логин'],
  ['users.table.last.login', 'Дата последнего входа'],
  ['printer.selection.cancel', 'Отмена'],
  ['printer.selection.ok', 'Ok'],
  ['printer.selection.title', 'Выбор принтера'],
  ['auth.token.connectionFailed', 'Невозможно подключится к crypto-ws'],
  ['auth.token.notFound', 'Не обнаружен ключ'],
  ['auth.token.incorrectPin', 'Авторизация невозможна'],
  ['auth.token.genericError', 'Произошла ошибка'],

  ['table-editor-diolog-component-cancel', 'Отмена'],
  ['table-editor-dialog-component-ok', 'Сохранить'],

  ['feedback.send.success', 'Cпасибо за Ваш отзыв.'],

  ['suggestion', 'Подсказка...'],
  ['save.qr.to.file', 'Сохранить данные qr-кода в файл'],

  ['application.update', 'Текущая версия приложения устарела, пожалуйста, обновите приложение через магазин.'],
  ['statements.load.request.error', 'Ошибка загрузки заявления'],
  ['wacom.sign.start', 'Начать'],
  ['wacom.sign.stop', 'Остановить'],
  ['wacom.sign.dash', 'Прочерк'],
  ['wacom.sign.clear', 'Очистить'],
  ['wacom.sign.error.get.videostream', 'Ошибка подключения к планшету wacom'],
  ['wacom.sign.error.get.sign.result', 'Ошибка планшета wacom при получении изображения подписи'],
  ['wacom.sign.error.stop.read.sign', 'Ошибка подключения к планшету wacom'],

  // Поля в форме ввода заявления ПСФ
  ['RequestFeaturesV2.desiredForeignPassportType', 'Тип паспорта'],
  ['RequestFeaturesV2.applicant.personIdentity.fullName.lastName', 'Фамилия'],
  ['RequestFeaturesV2.applicant.lastNameLat', 'Фамилия (лат.)'],
  ['RequestFeaturesV2.applicant.personIdentity.fullName.firstName', 'Имя'],
  ['RequestFeaturesV2.applicant.firstNameLat', 'Имя (лат.)'],
  ['RequestFeaturesV2.applicant.personIdentity.fullName.middleName', 'Отчество'],
  ['RequestFeaturesV2.applicant.gender', 'Пол'],
  ['RequestFeaturesV2.applicant.personIdentity.birthDate', 'Дата рождения'],
  ['RequestFeaturesV2.incapable', 'Недееспособен / ограниченно дееспособен'],
  ['RequestFeaturesV2.applicant.birthPlaceFull', 'Полное место рождения'],
  ['RequestFeaturesV2.applicant.identityDocument.type', 'Документ, удостоверяющий личность'],
  ['RequestFeaturesV2.cause', 'Получение паспорта'],
  ['RequestFeaturesV2.citizenshipCertificate.active', 'Заключение о наличии гражданства'],
  ['RequestFeaturesV2.independentChild', 'Ребёнок дееспособен'],
  ['RequestFeaturesV2.applicant.activeFPassport', 'Имеется действующий заграничный паспорт'],
  ['RequestFeaturesV2.applicant.activeFPassports.p1.next', 'Имеется второй заграничный паспорт'],
  ['RequestFeaturesV2.applicant.identityDocument.series', 'Серия'],
  ['RequestFeaturesV2.applicant.identityDocument.number', 'Номер'],
  ['RequestFeaturesV2.applicant.identityDocument.issuer', 'Выдан'],
  ['RequestFeaturesV2.applicant.identityDocument.issueDate', 'Дата выдачи'],
  ['RequestFeaturesV2.independentChildDocument.type', 'Тип документа'],
  ['RequestFeaturesV2.independentChildDocument.series', 'Серия'],
  ['RequestFeaturesV2.independentChildDocument.number', 'Номер'],
  ['RequestFeaturesV2.independentChildDocument.issuer', 'Выдан'],
  ['RequestFeaturesV2.independentChildDocument.issueDate', 'Дата выдачи'],
  ['RequestFeaturesV2.citizenshipCertificate.number', 'Номер'],
  ['RequestFeaturesV2.citizenshipCertificate.date', 'Дата выдачи'],
  ['RequestFeaturesV2.citizenshipCertificate.officerPost', 'Должность заверителя'],
  ['RequestFeaturesV2.citizenshipCertificate.officerName', 'Ф.И.О. заверителя'],
  ['RequestFeaturesV2.citizenshipCertificate.testimony', 'Текст заключения'],
  ['RequestFeaturesV2.applicant.permAddress.address.country', 'Страна'],
  ['RequestFeaturesV2.applicant.permAddress.address.admDivision', 'Субъект федерации'],
  ['RequestFeaturesV2.applicant.permAddress.address.region', 'Район'],
  ['RequestFeaturesV2.applicant.permAddress.address.settlement', 'Населенный пункт'],
  ['RequestFeaturesV2.applicant.permAddress.address.street', 'Улица'],
  ['RequestFeaturesV2.applicant.permAddress.address.building', 'Дом'],
  ['RequestFeaturesV2.applicant.permAddress.address.housing', 'Корпус'],
  ['RequestFeaturesV2.applicant.permAddress.address.structure', 'Строение'],
  ['RequestFeaturesV2.applicant.permAddress.address.flat', 'Квартира'],
  ['RequestFeaturesV2.applicant.permAddress.from', 'Дата регистрации'],
  ['RequestFeaturesV2.applicant.tempAddress.address.country', 'Страна'],
  ['RequestFeaturesV2.applicant.tempAddress.address.admDivision', 'Субъект федерации'],
  ['RequestFeaturesV2.applicant.tempAddress.address.region', 'Район'],
  ['RequestFeaturesV2.applicant.tempAddress.address.settlement', 'Населенный пункт'],
  ['RequestFeaturesV2.applicant.tempAddress.address.street', 'Улица'],
  ['RequestFeaturesV2.applicant.tempAddress.address.building', 'Дом'],
  ['RequestFeaturesV2.applicant.tempAddress.address.housing', 'Корпус'],
  ['RequestFeaturesV2.applicant.tempAddress.address.structure', 'Строение'],
  ['RequestFeaturesV2.applicant.tempAddress.address.flat', 'Квартира'],
  ['RequestFeaturesV2.applicant.tempAddress.from', 'Начало регистрации'],
  ['RequestFeaturesV2.applicant.tempAddress.to', 'Окончание'],
  ['RequestFeaturesV2.applicant.tempAddress.type', 'Aдрес'],
  ['RequestFeaturesV2.applicant.email', 'Email адрес'],
  ['RequestFeaturesV2.applicant.phone', 'Номер телефона'],
  ['RequestFeaturesV2.representative.personIdentity.fullName.lastName', 'Фамилия'],
  ['RequestFeaturesV2.representative.personIdentity.fullName.firstName', 'Имя'],
  ['RequestFeaturesV2.representative.personIdentity.fullName.middleName', 'Отчество'],
  ['RequestFeaturesV2.representative.personIdentity.birthDate', 'Дата рождения'],
  ['RequestFeaturesV2.representative.gender', 'Пол'],
  ['RequestFeaturesV2.representative.birthPlace', 'Место рождения'],
  ['RequestFeaturesV2.representative.identityDocument.type', 'Тип документа'],
  ['RequestFeaturesV2.representative.representativeProof.type', 'Документ, подтверждающий права законного представителя'],
  ['RequestFeaturesV2.representative.email', 'Email адрес'],
  ['RequestFeaturesV2.representative.phone', 'Номер телефона'],
  [
    'RequestFeaturesV2.representative.trustRecipient.active',
    'Законный представитель не возражает против получения паспорта другим законным представителем',
  ],
  ['RequestFeaturesV2.representative.identityDocument.series', 'Серия'],
  ['RequestFeaturesV2.representative.identityDocument.number', 'Номер'],
  ['RequestFeaturesV2.representative.identityDocument.issuer', 'Выдан'],
  ['RequestFeaturesV2.representative.identityDocument.issueDate', 'Дата выдачи'],
  ['RequestFeaturesV2.representative.representativeProof.series', 'Серия'],
  ['RequestFeaturesV2.representative.representativeProof.number', 'Номер'],
  ['RequestFeaturesV2.representative.representativeProof.issuer', 'Выдан'],
  ['RequestFeaturesV2.representative.representativeProof.issueDate', 'Дата выдачи'],
  ['RequestFeaturesV2.representative.permAddress.address.country', 'Страна'],
  ['RequestFeaturesV2.representative.permAddress.address.admDivision', 'Субъект федерации'],
  ['RequestFeaturesV2.representative.permAddress.address.region', 'Район'],
  ['RequestFeaturesV2.representative.permAddress.address.settlement', 'Населенный пункт'],
  ['RequestFeaturesV2.representative.permAddress.address.street', 'Улица'],
  ['RequestFeaturesV2.representative.permAddress.address.building', 'Дом'],
  ['RequestFeaturesV2.representative.permAddress.address.housing', 'Корпус'],
  ['RequestFeaturesV2.representative.permAddress.address.structure', 'Строение'],
  ['RequestFeaturesV2.representative.permAddress.address.flat', 'Квартира'],
  ['RequestFeaturesV2.representative.permAddress.from', 'Дата регистрации'],
  ['RequestFeaturesV2.representative.tempAddress.address.country', 'Страна'],
  ['RequestFeaturesV2.representative.tempAddress.address.admDivision', 'Субъект федерации'],
  ['RequestFeaturesV2.representative.tempAddress.address.region', 'Район'],
  ['RequestFeaturesV2.representative.tempAddress.address.settlement', 'Населенный пункт'],
  ['RequestFeaturesV2.representative.tempAddress.address.street', 'Улица'],
  ['RequestFeaturesV2.representative.tempAddress.address.building', 'Дом'],
  ['RequestFeaturesV2.representative.tempAddress.address.housing', 'Корпус'],
  ['RequestFeaturesV2.representative.tempAddress.address.structure', 'Строение'],
  ['RequestFeaturesV2.representative.tempAddress.address.flat', 'Квартира'],
  ['RequestFeaturesV2.representative.tempAddress.from', 'Начало регистрации'],
  ['RequestFeaturesV2.representative.tempAddress.to', 'Окончание'],
  ['RequestFeaturesV2.representative.tempAddress.type', 'Aдрес'],
  ['RequestFeaturesV2.representative.trustRecipient.personIdentity.fullName.lastName', 'Фамилия'],
  ['RequestFeaturesV2.representative.trustRecipient.personIdentity.fullName.firstName', 'Имя'],
  ['RequestFeaturesV2.representative.trustRecipient.personIdentity.fullName.middleName', 'Отчество'],
  ['RequestFeaturesV2.representative.trustRecipient.personIdentity.birthDate', 'Дата рождения'],
  ['RequestFeaturesV2.representative.trustRecipient.gender', 'Пол'],
  ['RequestFeaturesV2.representative.trustRecipient.birthPlace', 'Место рождения'],
  ['RequestFeaturesV2.secretAccess.value', 'Допуск к сведениям особой важности или совершенно секретным сведениям'],
  ['RequestFeaturesV2.secretAccess.organization', 'Организация'],
  ['RequestFeaturesV2.secretAccess.year', 'Год'],
  ['RequestFeaturesV2.contractObligations.value', 'Договорные или контрактные обязательства, препятствующие выезду за границу'],
  ['RequestFeaturesV2.contractObligations.organization', 'Организация'],
  ['RequestFeaturesV2.contractObligations.year', 'Год'],
  ['RequestFeaturesV2.militaryService', 'Призван(а) на военную или направлен(а) на альтернативную службу'],
  ['RequestFeaturesV2.convicted', 'Осужден(а) за совершение преступления'],
  ['RequestFeaturesV2.accused', 'Является подозреваемым или обвиняемым'],
  ['RequestFeaturesV2.legalObligations', 'Уклонение от обязательств, наложенных судом'],
  ['RequestFeaturesV2.dipServiceControlData.dutyOrganization', 'Направляющая организация'],
  ['RequestFeaturesV2.dipServiceControlData.dutyPosition', 'Должность, место работы'],
  ['RequestFeaturesV2.dipServiceControlData.dutyDuration', 'Срок'],
  ['RequestFeaturesV2.dipServiceControlData.dutyCountry', 'Страна'],
  ['RequestFeaturesV2.dipServiceControlData.secretAdmitted', 'Допуск по форме №1 и №2 к сведениям, составляющим гос. тайну'],
  [
    'RequestFeaturesV2.dipServiceControlData.secretAware',
    'Осведомлен(а) в сов. секретных или особой важности сведениях, составляющих гос. тайну',
  ],
  ['RequestFeaturesV2.dipServiceControlData.contracts', 'Договорные или контрактные обязательства, препятствующие выезду за границу'],
  ['RequestFeaturesV2.dipServiceControlData.trips', 'Был(а) ли ранее за границей'],
  ['RequestFeaturesV2.bankrupt', 'Признан(а) несостоятельным или банкротом'],
  ['RequestFeaturesV2.receptionUser', 'Ф.И.О. принявшего заявление'],
  ['RequestFeaturesV2.adultSpecialConditions', 'Особые условия'],
  ['RequestFeaturesV2.teenagerSpecialConditions', 'Особые условия для подростков'],
  ['RequestFeaturesV2.fingerprintsRequired', 'Отпечатки пальцев'],
  ['RequestFeaturesV2.mailing.active', 'Отправка почтой'],
  ['RequestFeaturesV2.citizenshipDecision.number', 'Номер заявления'],
  ['RequestFeaturesV2.citizenshipDecision.date', 'Дата решения'],
  ['RequestFeaturesV2.citizenshipDecision.officerPost', 'Должность руководителя'],
  ['RequestFeaturesV2.citizenshipDecision.article', 'Статья'],
  ['RequestFeaturesV2.citizenshipDecision.officerName', 'Ф.И.О. руководителя'],
  ['RequestFeaturesV2.presidentEdict.number', 'Номер указа'],
  ['RequestFeaturesV2.presidentEdict.date', 'Дата указа'],
  ['RequestFeaturesV2.soldierPermission.number', 'Номер справки'],
  ['RequestFeaturesV2.soldierPermission.date', 'Дата справки'],
  ['RequestFeaturesV2.soldierPermission.signerPost', 'Должность подписавшего справку'],
  ['RequestFeaturesV2.soldierPermission.signerName', 'Ф.И.О. подписавшего справку'],
  ['RequestFeaturesV2.soldierPermission.agreementNumber', 'Согласование УФСБ (ОФСБ) №'],
  ['RequestFeaturesV2.soldierPermission.agreementDate', 'Дата согласования УФСБ (ОФСБ) №'],
  ['RequestFeaturesV2.soldierPermission.deciderName', 'Ф.И.О. принявшего решения о выдаче паспорта'],
  ['RequestFeaturesV2.soldierPermission.militaryUnit', 'Номер военной части'],
  ['RequestFeaturesV2.mailing.addressRus', 'Адрес доставки'],
  ['RequestFeaturesV2.mailing.addressLat', 'Адрес доставки (лат.)'],
  ['RequestFeaturesV2.applicant.secondNationality', 'Второе гражданство'],
  ['RequestFeaturesV2.goal', 'Цель получения паспорта'],
  ['RequestFeaturesV2.applicant.jobManDate', 'Дата'],
  ['RequestFeaturesV2.applicant.hrManager.position', 'Должность'],
  ['RequestFeaturesV2.applicant.hrManager.fullName.firstName', 'Имя'],
  ['RequestFeaturesV2.applicant.hrManager.fullName.lastName', 'Фамилия'],
  ['RequestFeaturesV2.applicant.hrManager.fullName.middleName', 'Отчество'],
  ['RequestFeaturesV2.applicant.hrManager.phone', 'Телефон'],

  ['RequestFeatures.desiredForeignPassportType', 'Тип паспорта'],
  ['RequestFeatures.applicant.personIdentity.fullName.lastName', 'Фамилия'],
  ['RequestFeatures.applicant.lastNameLat', 'Фамилия (лат.)'],
  ['RequestFeatures.applicant.personIdentity.fullName.firstName', 'Имя'],
  ['RequestFeatures.applicant.firstNameLat', 'Имя (лат.)'],
  ['RequestFeatures.applicant.personIdentity.fullName.middleName', 'Отчество'],
  ['RequestFeatures.applicant.gender', 'Пол'],
  ['RequestFeatures.applicant.personIdentity.birthDate', 'Дата рождения'],
  ['RequestFeatures.incapable', 'Недееспособен / ограниченно дееспособен'],
  ['RequestFeatures.applicant.birthPlaceFull', 'Полное место рождения'],
  ['RequestFeatures.applicant.identityDocument.type', 'Документ, удостоверяющий личность'],
  ['RequestFeatures.cause', 'Получение паспорта'],
  ['RequestFeatures.citizenshipCertificate.active', 'Заключение о наличии гражданства'],
  ['RequestFeatures.independentChild', 'Ребёнок дееспособен'],
  ['RequestFeatures.applicant.activeFPassport', 'Имеется действующий заграничный паспорт'],
  ['RequestFeatures.applicant.activeFPassports.p1.next', 'Имеется второй заграничный паспорт'],
  ['RequestFeatures.applicant.identityDocument.series', 'Серия'],
  ['RequestFeatures.applicant.identityDocument.number', 'Номер'],
  ['RequestFeatures.applicant.identityDocument.issuer', 'Выдан'],
  ['RequestFeatures.applicant.identityDocument.issueDate', 'Дата выдачи'],
  ['RequestFeatures.independentChildDocument.type', 'Тип документа'],
  ['RequestFeatures.independentChildDocument.series', 'Серия'],
  ['RequestFeatures.independentChildDocument.number', 'Номер'],
  ['RequestFeatures.independentChildDocument.issuer', 'Выдан'],
  ['RequestFeatures.independentChildDocument.issueDate', 'Дата выдачи'],
  ['RequestFeatures.citizenshipCertificate.number', 'Номер'],
  ['RequestFeatures.citizenshipCertificate.date', 'Дата выдачи'],
  ['RequestFeatures.citizenshipCertificate.officerPost', 'Должность заверителя'],
  ['RequestFeatures.citizenshipCertificate.officerName', 'Ф.И.О. заверителя'],
  ['RequestFeatures.citizenshipCertificate.testimony', 'Текст заключения'],
  ['RequestFeatures.applicant.permAddress.country', 'Страна'],
  ['RequestFeatures.applicant.permAddress.index', 'Индекс'],
  ['RequestFeatures.applicant.permAddress.admDivision', 'Субъект федерации'],
  ['RequestFeatures.applicant.permAddress.region', 'Район'],
  ['RequestFeatures.applicant.permAddress.settlement', 'Населенный пункт'],
  ['RequestFeatures.applicant.permAddress.street', 'Улица'],
  ['RequestFeatures.applicant.permAddress.building', 'Дом'],
  ['RequestFeatures.applicant.permAddress.housing', 'Корпус'],
  ['RequestFeatures.applicant.permAddress.structure', 'Строение'],
  ['RequestFeatures.applicant.permAddress.flat', 'Квартира'],
  ['RequestFeatures.applicant.permAddress.phone', 'Номер телефона'],
  ['RequestFeatures.applicant.tempAddress.index', 'Индекс'],
  ['RequestFeatures.applicant.tempAddress.country', 'Страна'],
  ['RequestFeatures.applicant.tempAddress.admDivision', 'Субъект федерации'],
  ['RequestFeatures.applicant.tempAddress.region', 'Район'],
  ['RequestFeatures.applicant.tempAddress.settlement', 'Населенный пункт'],
  ['RequestFeatures.applicant.tempAddress.street', 'Улица'],
  ['RequestFeatures.applicant.tempAddress.building', 'Дом'],
  ['RequestFeatures.applicant.tempAddress.housing', 'Корпус'],
  ['RequestFeatures.applicant.tempAddress.structure', 'Строение'],
  ['RequestFeatures.applicant.tempAddress.flat', 'Квартира'],
  ['RequestFeatures.applicant.tempAddress.phone', 'Номер телефона'],
  ['RequestFeatures.applicant.jobManName', 'Фамилия должностного лица организации, телефон'],
  ['RequestFeatures.applicant.jobManDate', 'Дата'],
  ['RequestFeatures.applicant.hrManager.position', 'Должность'],
  ['RequestFeatures.applicant.hrManager.fullName.firstName', 'Имя'],
  ['RequestFeatures.applicant.hrManager.fullName.lastName', 'Фамилия'],
  ['RequestFeatures.applicant.hrManager.fullName.middleName', 'Отчество'],
  ['RequestFeatures.applicant.hrManager.phone', 'Телефон'],
  ['RequestFeatures.representative.personIdentity.fullName.lastName', 'Фамилия'],
  ['RequestFeatures.representative.personIdentity.fullName.firstName', 'Имя'],
  ['RequestFeatures.representative.personIdentity.fullName.middleName', 'Отчество'],
  ['RequestFeatures.representative.personIdentity.birthDate', 'Дата рождения'],
  ['RequestFeatures.representative.gender', 'Пол'],
  ['RequestFeatures.representative.birthPlace', 'Место рождения'],
  ['RequestFeatures.representative.identityDocument.type', 'Тип документа'],
  ['RequestFeatures.representative.email', 'Email адрес'],
  ['RequestFeatures.representative.phone', 'Номер телефона'],
  ['RequestFeatures.representative.identityDocument.series', 'Серия'],
  ['RequestFeatures.representative.identityDocument.number', 'Номер'],
  ['RequestFeatures.representative.identityDocument.issuer', 'Выдан'],
  ['RequestFeatures.representative.identityDocument.issueDate', 'Дата выдачи'],
  ['RequestFeatures.representative.address.text', 'Aдрес'],
  ['RequestFeatures.representative.trustRecipient.personIdentity.fullName.lastName', 'Фамилия'],
  ['RequestFeatures.representative.trustRecipient.personIdentity.fullName.firstName', 'Имя'],
  ['RequestFeatures.representative.trustRecipient.personIdentity.fullName.middleName', 'Отчество'],
  ['RequestFeatures.representative.trustRecipient.personIdentity.birthDate', 'Дата рождения'],
  ['RequestFeatures.representative.trustRecipient.gender', 'Пол'],
  ['RequestFeatures.representative.trustRecipient.birthPlace', 'Место рождения'],
  ['RequestFeatures.goal', 'Цель получения паспорта'],
  ['RequestFeatures.residenceCountry', 'Страна проживания'],
  ['RequestFeatures.applicant.secondNationality', 'Второе гражданство'],
  ['RequestFeatures.secretAccess', 'Допуск к сведениям особой важности или совершенно секретным сведениям'],
  ['RequestFeatures.departureRestrictions', 'Договорные или контрактные обязательства, препятствующие выезду за границу'],
  ['RequestFeatures.militaryService', 'Призван(а) на военную или направлен(а) на альтернативную службу'],
  ['RequestFeatures.conviction', 'Осужден(а) за совершение преступления'],
  ['RequestFeatures.legalObligations', 'Является подозреваемым или обвиняемым'],
  ['RequestFeatures.dipServiceControlData.dutyOrganization', 'Направляющая организация'],
  ['RequestFeatures.dipServiceControlData.dutyPosition', 'Должность, место работы'],
  ['RequestFeatures.dipServiceControlData.dutyDuration', 'Срок'],
  ['RequestFeatures.dipServiceControlData.dutyCountry', 'Страна'],
  ['RequestFeatures.dipServiceControlData.secretAdmitted', 'Допуск по форме №1 и №2 к сведениям, составляющим гос. тайну'],
  [
    'RequestFeatures.dipServiceControlData.secretAware',
    'Осведомлен(а) в сов. секретных или особой важности сведениях, составляющих гос. тайну',
  ],
  ['RequestFeatures.dipServiceControlData.contracts', 'Договорные или контрактные обязательства, препятствующие выезду за границу'],
  ['RequestFeatures.dipServiceControlData.trips', 'Был(а) ли ранее за границей'],
  ['RequestFeatures.receptionUser', 'Ф.И.О. принявшего заявление'],
  ['RequestFeatures.adultSpecialConditions', 'Особые условия'],
  ['RequestFeatures.teenagerSpecialConditions', 'Особые условия для подростков'],
  ['RequestFeatures.fingerprintsRequired', 'Отпечатки пальцев'],
  ['RequestFeatures.mailing.active', 'Отправка почтой'],
  ['RequestFeatures.citizenshipDecision.number', 'Номер заявления'],
  ['RequestFeatures.citizenshipDecision.date', 'Дата решения'],
  ['RequestFeatures.citizenshipDecision.officerPost', 'Должность руководителя'],
  ['RequestFeatures.citizenshipDecision.article', 'Статья'],
  ['RequestFeatures.citizenshipDecision.officerName', 'Ф.И.О. руководителя'],
  ['RequestFeatures.presidentEdict.number', 'Номер указа'],
  ['RequestFeatures.presidentEdict.date', 'Дата указа'],
  ['RequestFeatures.soldierPermission.number', 'Номер справки'],
  ['RequestFeatures.soldierPermission.date', 'Дата справки'],
  ['RequestFeatures.soldierPermission.signerPost', 'Должность подписавшего справку'],
  ['RequestFeatures.soldierPermission.signerName', 'Ф.И.О. подписавшего справку'],
  ['RequestFeatures.soldierPermission.agreementNumber', 'Номер согласования ФСБ'],
  ['RequestFeatures.soldierPermission.agreementDate', 'Дата согласования ФСБ'],
  ['RequestFeatures.soldierPermission.deciderName', 'Ф.И.О. принявшего решения о выдаче паспорта'],
  ['RequestFeatures.soldierPermission.militaryUnit', 'Номер военной части'],
  ['RequestFeatures.mailing.addressRus', 'Адрес доставки'],
  ['RequestFeatures.mailing.addressLat', 'Адрес доставки (лат.)'],
]);

// Export
export class ru_RU {
  constructor() {
    FeaturesI18N.addBundle('ru-RU', bundle);
  }
}
